import { useVeltClient, VeltRecorderTool, VeltRecorderControlPanel, VeltRecorderPlayer, VeltHuddleTool } from '@veltdev/react';
import { useEffect, useState } from 'react';
import YourAuthComponent from './YourAuthComponent';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  const [recordedData, setRecordedData] = useState([]);
  const [recordedDataComments, setRecordedDataComments] = useState([]);

    const tempRecordedData = [];
    const tempRecordedDataComments = [];


    {/* STEP 5.c */ }
    /**
     * Store this data at your end and use it to render the recorded data
     * @param {*} data 
     */
    const onRecordedData = (data) => {
        console.log('onRecordedData', data);
        if (!tempRecordedData?.find((recordingData) => recordingData.id === data.id)) {
            tempRecordedData.push(data);
            setRecordedData(tempRecordedData.slice());
        }
    }

    const onRecordedDataComments = (data) => {
      console.log('onRecordedDataComments', data);
      if (!tempRecordedDataComments?.find((recordingData) => recordingData.id === data.id)) {
          tempRecordedDataComments.push(data);
          setRecordedDataComments(tempRecordedDataComments.slice());
      }
  }


  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('unique-document-id-product-board-demo');
      let commentElement = client.getCommentElement()
      commentElement.disablePopoverMode();
    }
  }, [client]);

  return (
    <>
  <meta
    httpEquiv="Content-Security-Policy"
    content="base-uri optimize.google.com; object-src 'none'; script-src 'self' cdn.productboard.com blob: *.stripe.com use.typekit.net *.jquery.com unpkg.com/es6-promise@4.1.0/dist/es6-promise.min.js unpkg.com/whatwg-fetch@2.0.3/fetch.js ana-api.productboard.com ana-cdn.productboard.com *.intercom.io *.intercomcdn.com cdn.sprig.com google-analytics.com www.google-analytics.com www.googletagmanager.com www.googleadservices.com www.google.com optimize.google.com *.doubleclick.net cdn.heapanalytics.com heapanalytics.com cdn.mxpnl.com connect.facebook.net *.wistia.com *.wistia.net src.litix.io/core/2/mux.js *.hotjar.com *.ads-twitter.com *.licdn.com *.linkedin.com *.twitter.com d3pkntwtp2ukl5.cloudfront.net/uba.js t.unbounce.com pi.pardot.com *.clearbit.com clearbitjs.com *.marketo.net *.marketo.com *.productboard.com cdn.madkudu.com ajax.cloudflare.com/cdn-cgi/scripts/7089c43e/cloudflare-static/rocket-loader.min.js *.zdassets.com *.6sc.co *.dopt.com 'nonce-j6h1nk789hJT2yPuWa2I7A==' 'nonce-bHfKftaLoUigTfkVHzU5+Q==' 'nonce-6XEx9eOemXquW1WWUpUOZw==' 'nonce-Jz/kEry/JukJt5waRt3VFg==' 'nonce-PMkyhz8IzzmNwIY/dkWuhA==' 'nonce-hX2rNfoINF4m8HtZn/QtaQ==' 'nonce-PSg49gJqgUqaOVsBa1bCVA==' 'strict-dynamic'; style-src 'self' 'unsafe-inline' cdnjs.cloudflare.com use.typekit.net p.typekit.net cdn.productboard.com heapanalytics.com maxcdn.bootstrapcdn.com *.marketo.com info.productboard.com optimize.google.com; default-src 'self'; font-src 'self' cdn.productboard.com data: use.typekit.net fonts.typekit.net *.intercomcdn.com *.wistia.com heapanalytics.com maxcdn.bootstrapcdn.com; frame-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; child-src *.stripe.com *.wistia.com *.wistia.net *.vimeo.com *.youtube.com *.doubleclick.net *.productboard.com *.marketo.com optimize.google.com *.hotjar.com intercom-sheets.com intercom-reporting.com *.loom.com miro.com *.miro.com *.figma.com *.mural.co; form-action https://intercom.help https://api-iam.intercom.io *.productboard.com *.productboard.info; img-src * data: blob: heapanalytics.com https://js.intercomcdn.com https://static.intercomassets.com https://downloads.intercomcdn.com https://downloads.intercomcdn.eu https://downloads.au.intercomcdn.com https://uploads.intercomusercontent.com https://gifs.intercomcdn.com  https://video-messages.intercomcdn.com https://messenger-apps.intercom.io https://messenger-apps.eu.intercom.io https://messenger-apps.au.intercom.io https://*.intercom-attachments-1.com https://*.intercom-attachments.eu https://*.au.intercom-attachments.com https://*.intercom-attachments-2.com https://*.intercom-attachments-3.com https://*.intercom-attachments-4.com https://*.intercom-attachments-5.com https://*.intercom-attachments-6.com https://*.intercom-attachments-7.com https://*.intercom-attachments-8.com https://*.intercom-attachments-9.com https://static.intercomassets.eu https://static.au.intercomassets.com; connect-src 'self' 'self' blob: cdn.productboard.com nucleus.productboard.net *.pusher.com wss://ws.pusherapp.com:443 wss://ws.pusherapp.com wss://ws-eu.pusherapp.com:443 wss://ws-eu.pusherapp.com wss://ws-eu.pusher.com wss://ws-mt1.pusher.com ana-api.productboard.com *.segment.com api.intercom.io api.au.intercom.io api.eu.intercom.io api-iam.intercom.io api-iam.eu.intercom.io api-iam.au.intercom.io  api-ping.intercom.io   nexus-websocket-a.intercom.io wss://nexus-websocket-a.intercom.io nexus-websocket-b.intercom.io wss://nexus-websocket-b.intercom.io nexus-europe-websocket.intercom.io  wss://nexus-europe-websocket.intercom.io  nexus-australia-websocket.intercom.io wss://nexus-australia-websocket.intercom.io  uploads.intercomcdn.com uploads.intercomcdn.eu  uploads.au.intercomcdn.com  uploads.intercomusercontent.com  *.intercomcdn.com api.sprig.com vc.hotjar.io *.typekit.net api.mixpanel.com *.wistia.com *.wistia.net *.facebook.com api.trello.com embedwistia-a.akamaihd.net heapanalytics.com *.googlesyndication.com *.google.com www.google-analytics.com *.litix.io *.clearbit.com *.mktoresp.com *.launchdarkly.com api.honeycomb.io *.hotjar.com wss://*.hotjar.com *.ingest.sentry.io *.doubleclick.net *.browser-intake-datadoghq.com https://api.amplitude.com https://api2.amplitude.com *.zdassets.com widget-mediator.zopim.com wss://widget-mediator.zopim.com productboard.zendesk.com *.6sc.co *.adnxs.com *.loom.com app.satismeter.com *.dopt.com wss://*.dopt.com; media-src 'self' data: blob: *.intercomcdn.com embedwistia-a.akamaihd.net *.wistia.com cdn.productboard.com nucleus.productboard.net *.zdassets.com cdn.loom.com; worker-src 'self' blob:"
  />
  <meta charSet="utf-8" />
  <meta name="referrer" content="origin" />
  <title>Feature planning (sample) | Productboard</title>
  <meta
    name="description"
    content="Get the right products to market, faster."
  />
  <meta property="og:title" content="Productboard" />
  <meta
    property="og:description"
    content="Get the right products to market, faster."
  />
  <meta name="revision" content="c5506e14b3ed13a60348f9f866f4114b024f9f7e" />
  <section id="react" className="is-viewer">
    <div className="animated-componentstyled__fade-sc-12t1a22-0 hkNeWR appear-done enter-done">
      <div className="application-content__ApplicationContainer-sc-1k5swnc-0 fRmFgP">
        <div className="application-content__Application-sc-1k5swnc-1 gaQKLZ">
          <div className="main-menu-expand-button__Container-sc-a3nm2x-0 lfcfkH">
            <div className="box__StyledBox-sc-b30x7m-0 huKWQq">
              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                <button
                  type="button"
                  aria-label="Collapse menu"
                  data-nc="true"
                  data-testid="Header-MenuButton"
                  className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                >
                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="CollapseNavigationIcon"
                      className="sc-11y93t1-0 dqXaRM ui-icon"
                    >
                      <path
                        d="M8 2h6v2H8V2ZM14 12H8v2h6v-2ZM14 7H8v2h6V7Z"
                        fill="currentColor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m.317 7.221 3.831-3.897a1.07 1.07 0 0 1 1.533 0c.423.43.423 1.128 0 1.558L2.616 8l3.065 3.118a1.117 1.117 0 0 1 0 1.56c-.423.43-1.11.43-1.533 0L.318 8.78a1.116 1.116 0 0 1 0-1.559Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </button>
              </span>
            </div>
          </div>
          <header width={256} className="main-menu__Header-sc-1px38at-0 ddVgTE">
            <div
              style={{
                position: "relative",
                userSelect: "auto",
                width: 256,
                height: "100%",
                maxWidth: 480,
                minWidth: 240,
                boxSizing: "border-box",
                flexShrink: 0
              }}
            >
              <div className="flexstyled__StyledFlex-sc-lvlevv-0 jNTZsy">
                <div
                  data-testid="Account-Menu"
                  className="header__Trigger-sc-msz0fa-1 jQTgDt"
                >
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 eqxftF">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 gCQyQp">
                      <svg
                        height="20px"
                        viewBox="0 0 162 108"
                        data-testid="AppHeader-Logo"
                        data-nc="true"
                      >
                        <path
                          fill="#0071E1"
                          d="M108.001 0L162 54l-54.001 54-53.996-54L108 0z"
                        />
                        <path
                          fill="#FFC600"
                          d="M107.997 0L53.999 54 0 0h107.997z"
                        />
                        <path
                          fill="#F84136"
                          d="M53.999 54l53.998 54H0l53.999-54z"
                        />
                      </svg>
                    </div>
                    <div
                      data-nc="true"
                      className="heading__StyledHeading-sc-114dp0l-0 XDuDU"
                    >
                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                        <span className="header__HeadingWrapper-sc-msz0fa-0 gcTzuh">
                          <YourAuthComponent/>
                        </span>
                      </span>
                    </div>
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="ArrowCaretIcon"
                      className="sc-11y93t1-0 xIpMQ ui-icon"
                    >
                      <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="flexstyled__StyledFlex-sc-lvlevv-0 jaLSkS">
                <div className="quickfind__Container-sc-b1ll48-0 eZSrsz">
                  <div className="menu-item__Item-sc-18xys5o-1 jwMyEu">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                      <svg
                        height="16px"
                        width="16px"
                        viewBox="0 0 16 16"
                        role="img"
                        aria-label="SearchIcon"
                        className="sc-11y93t1-0 kqDcRj ui-icon"
                      >
                        <path
                          fill="currentColor"
                          fillRule="evenodd"
                          d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNrzLm">
                        <div className="menu-item__Label-sc-18xys5o-0 fTajIn">
                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                <span
                                  data-testid="Quickfind-MenuItem"
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 kURyuR"
                                >
                                  Find board
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-testid="Quickfind-Modal" />
                </div>
                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 gyXsuf">
                  <button
                    type="button"
                    aria-label="Notifications"
                    data-nc="true"
                    data-testid="NotificationCenter-Button"
                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                  >
                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                      <div className="sc-1bp6zuu-0 dqbDkO">
                        <svg
                          height="16px"
                          width="16px"
                          viewBox="0 0 16 16"
                          role="img"
                          aria-label="NotificationIcon"
                          className="sc-11y93t1-0 xIpMQ ui-icon"
                        >
                          <path
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M15 11.999h-1V8c0-3.589-3.725-8-6-8S2 4.411 2 8v3.999H1A1 1 0 0 0 1 14h4c0 1.104 1.343 2 3 2 1.656 0 3-.896 3-2h4a1 1 0 0 0 0-2.001zm-11 0v-3C4 5.208 6.987 2 8 2s3.999 3.333 3.999 6.999v3H4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                  </button>
                </span>
              </div>
              <div
                data-testid="main-menu-scroll-container"
                className="main-menu__ScrollContainer-sc-1px38at-1 cEGlbj"
              >
                <div className="scroll-shadow__StyledScrollShadow-sc-19nlq98-0 dWqUOp main-menu___StyledScrollShadow-sc-1px38at-4 iQrqyW">
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 jFTdor main-menu___StyledFlex-sc-1px38at-5 ihhPDO">
                    <div className="main-menu__ScrollContainerContent-sc-1px38at-2 ewMtvs">
                      <div
                        className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                        data-testid="StaticMenu"
                      >
                        <div className="static-menu-itemstyled__HomeStaticItemContainer-sc-jveuem-0 emwIkj">
                          <a
                            data-testid="StaticMenuItem"
                            tabIndex={0}
                            data-nc="true"
                            className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                            href="/home"
                          >
                            <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                      <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="HomeIcon"
                                          className="sc-11y93t1-0 xIpMQ ui-icon"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 10.03c-.6 0-1 .4-1 1v3H3v-7.5l5-4.2 5 4.2v7.5h-2v-3c0-.6-.4-1-1-1H6ZM10 16h4c.6 0 1-.4 1-1V6.03c0-.3-.1-.6-.4-.8l-6-5c-.4-.3-.9-.3-1.3 0l-6 5c-.2.2-.3.5-.3.8V15c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-2.97h2V15c0 .6.4 1 1 1Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                    <div
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                    >
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                            <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                              <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                Home
                                              </div>
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/teamspaces/all"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="AllTeamspacesIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              All teamspaces
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                        <div
                          data-testid="MainMenuSection-Favorites"
                          className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                        >
                          <div
                            className="a6XhA2vk2hktu_NcQWh7"
                            role="heading"
                            data-testid="Group-Heading"
                          >
                            Favorites
                          </div>
                          <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                            <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="ChevronRightIcon"
                                className="sc-11y93t1-0 xIpMQ ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        display="flex"
                        className="box__StyledBox-sc-b30x7m-0 latrRT"
                      >
                        <span
                          data-nc="true"
                          className="textstyled__StyledText-sc-cx1866-0 dOIxr"
                        >
                          No boards yet
                        </span>
                      </div>
                      <div className="navigation-sections__Wrapper-sc-ng4kon-0 evgVDh">
                        <div className="navigation-teamspace-coachmark__AttachableCoachmarkPlaceholder-sc-4bu7ey-0 dNoCXR" />
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                          <div
                            data-testid="MainMenuSection-Teamspaces"
                            className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                          >
                            <div
                              className="a6XhA2vk2hktu_NcQWh7"
                              role="heading"
                              data-testid="Group-Heading"
                            >
                              Teamspaces
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                              <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="ChevronRightIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 hqdVxL">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                              <a href="/teamspaces/all">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    aria-label="All teamspaces"
                                    data-nc="true"
                                    data-testid="all-team-spaces-button"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                  >
                                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="AllTeamspacesIcon"
                                        className="sc-11y93t1-0 dqXaRM ui-icon"
                                      >
                                        <path
                                          d="M2 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H2ZM2 7a1 1 0 0 0 0 2h3.59c.134-.727.41-1.403.8-2H2ZM5.875 12a5.508 5.508 0 0 0 1.35 2H2a1 1 0 1 1 0-2h3.875Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12.5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.165 3.08a3.5 3.5 0 1 1 1.414-1.414l1.163 1.162a1 1 0 1 1-1.414 1.414l-1.163-1.163Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </div>
                                  </button>
                                </span>
                              </a>
                            </div>
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                              <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    aria-label="Create a new teamspace"
                                    data-nc="true"
                                    data-testid="create-teamspace-section-button"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                  >
                                    <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="PlusCircleIcon"
                                        className="sc-11y93t1-0 dqXaRM ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M8 .001a8 8 0 1 0 0 15.998A8 8 0 1 0 8 .001zm0 13.998A6.006 6.006 0 0 1 1.999 8 6.006 6.006 0 0 1 8 2.001c3.308 0 6 2.69 6 5.999a6.006 6.006 0 0 1-6 5.999zM11.01 7H8.999V4.99A.989.989 0 0 0 8.01 4h-.021A.99.99 0 0 0 7 4.99V7H4.99a.99.99 0 0 0-.99.99v.02c0 .547.443.99.99.99H7v2.01c0 .547.443.99.989.99h.021a.989.989 0 0 0 .989-.99V9h2.011a.99.99 0 0 0 .99-.99v-.02a.99.99 0 0 0-.99-.99z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          display="inherit"
                          className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                        >
                          <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                            <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                              <ul
                                data-testid="TeamspacesNavigationSection"
                                role="listbox"
                                className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                              >
                                <li data-spacer="true" style={{ height: 4 }} />
                                <li
                                  data-index={0}
                                  data-id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                  role="presentation"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="TeamspaceItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceIcon"
                                                    className="sc-11y93t1-0 cRyrkY ui-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpUZWFtc3BhY2U6MmY1YjU5NzctMjBjZC00YzVlLWJkNWItMWExM2IwM2E4ODkx"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          General
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Generalboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={1}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderOpenIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M2 2h11v5H2z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                      fill="currentColor"
                                                    />
                                                    <path
                                                      d="M3 6h12l-2 8H1l2-8Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOmYxYTZhNGIzLTQ3MmMtNDYwNS04ZDgyLTU4Mzc3YzI2YTczOA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature boards
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Feature boardsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={2}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/feature-board/7450405-feature-planning-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 krOJcX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6M2YwYTA2NzItMTAwZi00MjRjLTg3ODQtZTM2OTYwMDJlODNm"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature planning
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={3}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/feature-board/7450406-feature-prioritization-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6NjlkMjJjMGItYWEzYi00NTUxLTg1YmEtN2VhN2ViMjNhMThl"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature prioritization
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={4}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NzkwNTBiOTMtMDEwNi00YzI1LWFhZjUtZGY5ZTVhOWFkNWY1"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="BoardItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feedback-driven
                                                          prioritization
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                  <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                    <svg
                                                      height="12px"
                                                      width="12px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="UpgradeIcon"
                                                      className="sc-11y93t1-0 gwBFtq ui-icon"
                                                    >
                                                      <path
                                                        d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                        fill="currentColor"
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                    <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                      <span
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                      >
                                                        Pro
                                                      </span>
                                                    </div>
                                                  </div>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={5}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NDBjYjViYTMtNTE0MC00ZDdmLTllZTktNGFhNTNmMDkwMGU2"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="BoardItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 hSQxpg"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 zsdBX">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="FeaturesBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M7 2H5v3H2v2h3v7h2V7h7V5H7V2Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Objective-driven
                                                          prioritization
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz">
                                                  <div className="premium-badgestyled__FusionBadgeContainer-sc-f89j6e-1 dRDqqN">
                                                    <svg
                                                      height="12px"
                                                      width="12px"
                                                      viewBox="0 0 16 16"
                                                      role="img"
                                                      aria-label="UpgradeIcon"
                                                      className="sc-11y93t1-0 gwBFtq ui-icon"
                                                    >
                                                      <path
                                                        d="M16 10.5c0-1-.839-1.338-1.75-1.75-.964-.435-1.516-.988-2-2C11.819 5.848 11.5 5 10.5 5s-1.355.831-1.75 1.75c-.435 1.012-.988 1.565-2 2C5.831 9.145 5 9.5 5 10.5s.848 1.319 1.75 1.75c1.012.484 1.565 1.036 2 2 .435.964.75 1.75 1.75 1.75s1.266-.786 1.75-1.75 1.036-1.516 2-2S16 11.5 16 10.5zM6 3c0-.545-.457-.73-.955-.955-.525-.237-.826-.538-1.09-1.09C3.719.462 3.545 0 3 0c-.545 0-.739.453-.955.955-.237.552-.538.853-1.09 1.09C.453 2.261 0 2.455 0 3c0 .545.462.72.955.955.552.264.853.565 1.09 1.09.238.526.41.955.955.955.545 0 .69-.429.955-.955.264-.525.565-.826 1.09-1.09C5.571 3.69 6 3.545 6 3z"
                                                        fill="currentColor"
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                      />
                                                    </svg>
                                                    <div className="premium-badgestyled__PlanNameContainer-sc-f89j6e-0 YzjNY">
                                                      <span
                                                        data-nc="true"
                                                        className="textstyled__StyledText-sc-cx1866-0 fCUahr"
                                                      >
                                                        Enterprise
                                                      </span>
                                                    </div>
                                                  </div>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={6}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 bocYtX"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 dUZVXr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderOpenIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M2 2h11v5H2z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2 0C1.473 0 .956.18.568.568.18.956 0 1.473 0 2v12a1 1 0 1 0 2 0V2h5.986l.007.007 1.7 1.7A1 1 0 0 0 10.4 4H13v2a1 1 0 1 0 2 0V4c0-.527-.18-1.044-.568-1.432C14.044 2.18 13.527 2 13 2h-2.186L9.407.593A2.034 2.034 0 0 0 8.794.16 1.93 1.93 0 0 0 8 0H2Z"
                                                      fill="currentColor"
                                                    />
                                                    <path
                                                      d="M3 6h12l-2 8H1l2-8Z"
                                                      fill=""
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M2.03 5.757A1 1 0 0 1 3 5h12a1 1 0 0 1 .97 1.243l-2 8A1 1 0 0 1 13 15H1a1 1 0 0 1-.97-1.242l2-8ZM3.78 7l-1.5 6h9.94l1.5-6H3.78Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOjZmZWFmYmI5LTU2YWYtNDc5OC1iMzZlLTQ2N2YyMWQyOGYzZA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Roadmaps
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Roadmapsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={7}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450412-feature-launch-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6MzBmMTM0MjAtOTg4Yy00Nzg4LWEyMmUtY2Y1YWI1MjA4NmJh"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature launch roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={8}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450409-kanban-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6OTFhZGQ1OTQtMjM3Ni00ZWU4LThhMGYtMDNiNWRkMzNkYTNl"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Kanban roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={9}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450410-sprint-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6NTNmYjU1ZDctNjhhNC00ODhlLTk4ZWItNTFjYWE2OTA1MTdm"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Sprint roadmap
                                                          (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                                <li
                                  data-index={10}
                                  data-id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <a
                                      data-testid="BoardItem"
                                      tabIndex={0}
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 buSfGB"
                                      href="/roadmap/7450411-features-timeline-roadmap-sample"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 fsyLuv">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="RoadmapBoardIcon"
                                                    className="sc-11y93t1-0 dEkNOy ui-icon"
                                                  >
                                                    <rect
                                                      x={1}
                                                      y={1}
                                                      width={14}
                                                      height={14}
                                                      rx={3}
                                                      stroke="currentColor"
                                                      strokeWidth={2}
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M0 5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1Zm5 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm6 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uQm9hcmQ6OWY4YjRmYTUtYWZjYi00M2IwLWI1ZmMtZDU0NDYyZjk3MmRh"
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Features timeline
                                                          roadmap (sample)
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <button
                                                      type="button"
                                                      aria-label="Show more"
                                                      data-nc="true"
                                                      data-testid="Board-ContextMenu"
                                                      className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                    >
                                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                        <svg
                                                          height="16px"
                                                          width="16px"
                                                          viewBox="0 0 16 16"
                                                          role="img"
                                                          aria-label="DotsIcon"
                                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                                        >
                                                          <path
                                                            fill="currentColor"
                                                            fillRule="evenodd"
                                                            d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                            clipRule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </button>
                                                  </span>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </li>
                              </ul>
                              <div
                                data-testid="ListHeadless-KeyboardAnchor"
                                tabIndex={0}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                          <div
                            data-testid="MainMenuSection-Personal"
                            className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                          >
                            <div
                              className="a6XhA2vk2hktu_NcQWh7"
                              role="heading"
                              data-testid="Group-Heading"
                            >
                              Personal
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                              <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                <svg
                                  height="16px"
                                  width="16px"
                                  viewBox="0 0 16 16"
                                  role="img"
                                  aria-label="ChevronRightIcon"
                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                >
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div className="pull__StyledPull-sc-9ujoh3-0 hnawlo">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <button
                                type="button"
                                aria-label="Show more"
                                data-nc="true"
                                data-testid="add-Personalboard-left-nav"
                                className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                              >
                                <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="PlusIcon"
                                    className="sc-11y93t1-0 dqXaRM ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </span>
                          </div>
                        </div>
                        <div
                          display="inherit"
                          className="box__StyledBox-sc-b30x7m-0 dYVUUv"
                        >
                          <div className="list-headlessstyled__Wrapper-sc-ca3ui9-2 ckltsV">
                            <div className="list-headlessstyled__StyledListContainer-sc-ca3ui9-0 lhqdBH">
                              <ul
                                data-testid="PersonalNavigationSection"
                                role="listbox"
                                className="list-headlessstyled__StyledList-sc-ca3ui9-1 cejUwb"
                              >
                                <li data-spacer="true" style={{ height: 4 }} />
                                <li
                                  data-index={0}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-1"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M1 3h14v11H1z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOmU4NGNmNjA4LWExNWMtNGUwNi1hYjk4LTVlNDdiNDhlOTk0OA=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Feature boards
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Feature boardsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li
                                  data-index={1}
                                  data-id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                  role="option"
                                  className="sortable-item-container__ItemWrapper-sc-1a6q2yp-0 bREiLJ"
                                >
                                  <div
                                    role="button"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-1"
                                    className="sortable-item-container__SortableItemContainerElement-sc-1a6q2yp-1 fVfeNr"
                                  >
                                    <div
                                      tabIndex={0}
                                      data-testid="FolderItem"
                                      data-nc="true"
                                      className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 fxmTMQ"
                                    >
                                      <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 iHfdzr">
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                                <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                                  <svg
                                                    height="16px"
                                                    width="16px"
                                                    viewBox="0 0 16 16"
                                                    role="img"
                                                    aria-label="TeamspaceFolderIcon"
                                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                                  >
                                                    <path
                                                      fill=""
                                                      d="M1 3h14v11H1z"
                                                    />
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M1 0C.448 0 0 .478 0 1.067V13c0 1.178.895 2 2 2h12a2 2 0 0 0 2-2V4.267C16 3.088 15.105 2 14 2h-3.5L9.3.427A.98.98 0 0 0 8.5 0H1Zm13 5c0-.59-.448-1-1-1H3c-.552 0-1 .41-1 1v7c0 .59.448 1 1 1h10a1 1 0 0 0 1-1V5Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              id="MTpOYXZpZ2F0aW9uRm9sZGVyOjRkYjkwNmM0LTNhNjktNGYwNi04Yzg2LTgyMjY4Y2I4NmJiZg=="
                                              className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx"
                                            >
                                              <div
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                              >
                                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                                        <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                                          Roadmaps
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                                <span className="list-item-primitivestyled__SlotRightHover-sc-1its6wp-1 eyYXoY">
                                                  <div
                                                    display="flex"
                                                    className="box__StyledBox-sc-b30x7m-0 ksmEod"
                                                  >
                                                    <div className="box__StyledBox-sc-b30x7m-0 iAJZvK">
                                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                        <button
                                                          type="button"
                                                          aria-label="Show more"
                                                          data-nc="true"
                                                          data-testid="Folder-ContextMenu"
                                                          className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                        >
                                                          <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                            <svg
                                                              height="16px"
                                                              width="16px"
                                                              viewBox="0 0 16 16"
                                                              role="img"
                                                              aria-label="DotsIcon"
                                                              className="sc-11y93t1-0 dqXaRM ui-icon"
                                                            >
                                                              <path
                                                                fill="currentColor"
                                                                fillRule="evenodd"
                                                                d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </button>
                                                      </span>
                                                    </div>
                                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                      <button
                                                        type="button"
                                                        aria-label="Show more"
                                                        data-nc="true"
                                                        data-testid="add-Roadmapsboard-left-nav"
                                                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                                                      >
                                                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                                          <svg
                                                            height="16px"
                                                            width="16px"
                                                            viewBox="0 0 16 16"
                                                            role="img"
                                                            aria-label="PlusIcon"
                                                            className="sc-11y93t1-0 dqXaRM ui-icon"
                                                          >
                                                            <path
                                                              fill="currentColor"
                                                              fillRule="evenodd"
                                                              d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                                              clipRule="evenodd"
                                                            />
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </span>
                                                  </div>
                                                </span>
                                                <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <div
                                data-testid="ListHeadless-KeyboardAnchor"
                                tabIndex={0}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="flexstyled__StyledFlex-sc-lvlevv-0 jbiJGI"
                        data-testid="DataMenu"
                      >
                        <div className="box__StyledBox-sc-b30x7m-0 kQacQF">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iWGSBI">
                            <div
                              data-testid="MainMenuSection-Data"
                              className="aQtvNH57rQ2aDhR0rFoO SSTUk48f0NaxSIz78L4p"
                            >
                              <div
                                className="a6XhA2vk2hktu_NcQWh7"
                                role="heading"
                                data-testid="Group-Heading"
                              >
                                Data
                              </div>
                              <div className="box__StyledBox-sc-b30x7m-0 fozsyQ">
                                <div className="ED7PTTzZKaf50YJaEiah AMo072Uu2MoQi0B9SHI1">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ChevronRightIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M10.682 8.779 6.85 12.676a1.07 1.07 0 0 1-1.533 0 1.115 1.115 0 0 1 0-1.558L8.383 8 5.318 4.882a1.117 1.117 0 0 1 0-1.56c.423-.43 1.11-.43 1.533 0l3.83 3.898a1.116 1.116 0 0 1 0 1.559z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/drivers-scores"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DriverIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M14 0H2c-.553 0-1 .447-1 .999V15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V.999A1 1 0 0 0 14 0zM5 14H3v-2h2v2zm0-3.001H3V9h2v1.999zM5 8H3V6h2v2zm4 6H7v-2h2v2zm0-3.001H7V9h2v1.999zM9 8H7V6h2v2zm4 6h-2v-2h2v2zm0-3.001h-2V9h2v1.999zM13 8h-2V6h2v2zm0-4H3V2h10v2z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Drivers &amp; Scores
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/releases"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="ReleaseIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <g fill="currentColor">
                                          <path d="M0 15a1 1 0 1 0 2 0V1a1 1 0 0 0-2 0v14z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M15.793 1.588A.95.95 0 0 0 16 1c0-.552-.484-1-1.08-1H5.16C3.967 0 3 .895 3 2v7c0 1.105.967 2 2.16 2h9.76c.228 0 .45-.067.635-.191.483-.325.59-.95.238-1.397L13 5.5l2.793-3.912zM10.543 5.5l2.5-3.5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.042l-2.5-3.5z"
                                            clipRule="evenodd"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Releases
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/tasks"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="TaskIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 0 1 8 2c1.809 0 3.426.803 4.525 2.068-.148.05-.289.125-.408.237L7.698 8.478 5.878 6.76a1.15 1.15 0 0 0-1.56 0 1 1 0 0 0 0 1.473l2.6 2.454a1.151 1.151 0 0 0 1.56 0l5.12-4.834C13.854 6.52 14 7.242 14 8a6 6 0 0 1-6 6z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Tasks
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          data-testid="StaticMenuItem"
                          tabIndex={0}
                          data-nc="true"
                          className="list-item-primitivestyled__Wrapper-sc-1its6wp-6 kKboVF"
                          href="/data/default-fields"
                        >
                          <div className="list-item-primitivestyled__StyledContent-sc-1its6wp-4 csBFbz">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 cUWsko">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 ciaEGt">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 iNEPPA">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 cHbbMj">
                                    <div className="list-item-primitivestyled__IconWrapper-sc-1its6wp-8 buRgWM">
                                      <svg
                                        height="16px"
                                        width="16px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div className="list-item-primitivestyled__ContentWrapper-sc-1its6wp-7 kUmrrx">
                                  <div
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 bWSTqR"
                                  >
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jGygzl">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                          <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                            <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                              Default Fields
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-item-primitivestyled__SlotRightWrapper-sc-1its6wp-2 dMIQNL">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 gFLWZN">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                    <span className="list-item-primitivestyled__SlotRightPermanent-sc-1its6wp-0 ikIFxz" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="main-menu__ScrollContainerFiller-sc-1px38at-3 jDUtYe" />
                    <div className="trial-progress__TrialProgressFooter-sc-1921okl-0 emEYZt">
                      <div className="expanded-trial-period__ExpandedWrapper-sc-hvxksn-0 guvfZL">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 dGHbcT">
                          <div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 byMfUs"
                            >
                              14
                            </span>{" "}
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eheNCz"
                            >
                              days left
                            </span>
                          </div>
                          <button
                            type="button"
                            data-nc="true"
                            className="button-primitive__StyledButton-sc-1guvopt-0 fkgSPA"
                          >
                            <span className="button-primitive__StyledContent-sc-1guvopt-1 jnjmlp">
                              <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                Buy now
                              </span>
                            </span>
                          </button>
                        </div>
                      </div>
                      <button
                        data-nc="true"
                        className="linkstyled__Link-sc-14qwv7c-0 fkgqsY"
                      >
                        <span className="linkstyled__Text-sc-14qwv7c-2 bdTmqZ">
                          Try different plan
                        </span>
                      </button>
                      <VeltRecorderControlPanel panelId="1" mode="floating" onRecordedData={(data) => onRecordedData(data)} />

                      <VeltRecorderControlPanel panelId="2" mode="floating" onRecordedData={(data) => onRecordedDataComments(data)} />

                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  className=""
                  style={{
                    position: "absolute",
                    userSelect: "none",
                    width: 7,
                    height: "100%",
                    top: 0,
                    cursor: "col-resize",
                    right: "-3px"
                  }}
                >
                  <div
                    direction="vertical"
                    className="resize-handle__HandleContainer-sc-1idsfk7-1 hRNShL"
                  >
                    <div
                      direction="vertical"
                      className="resize-handle__HandleDivider-sc-1idsfk7-0 wxlNu"
                    />
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className="WRgq_U97OawHo6EQhRRQ">
            <div className="animated-componentstyled__fade-sc-12t1a22-0 ecvVSH Mg_bVvVOl9HZYGa9blNT appear-done enter-done" />
          </div>
          <div data-hotkeys-layer="true" tabIndex={-1} style={{}} />
          <div
            data-hotkeys-layer="true"
            tabIndex={-1}
            className="yBJwXyELiLiu7DixffkE"
            style={{}}
          >
            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iCCEGT">
              <div className="header-container__Container-sc-1eys2lk-0 jCSzOb">
                <div className="flexstyled__StyledFlex-sc-lvlevv-0 hUBHRF">
                  <div className="header-primary__LeftContainer-sc-179e15q-0 ctEHxx">
                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 jSxgqC">
                      <div className="header-primary__SelectableTitle-sc-179e15q-1 dHnedO">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 cquxeH">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 iEFJYo">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 SgsON">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="TeamspaceIcon"
                                className="sc-11y93t1-0 cRyrkY ui-icon"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                                  fill=""
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 4c-1.2 0-2.2.5-2.9 1.3L6.9 4.2c.1-.2.1-.5.1-.7C7 1.6 5.4 0 3.5 0S0 1.6 0 3.5c0 1.4.8 2.6 2 3.1v2.7c-1.2.6-2 1.8-2 3.1 0 2 1.6 3.6 3.5 3.6S7 14.4 7 12.5c0-.2 0-.5-.1-.7L9 10.7c.8.8 1.8 1.3 3 1.3 2.2 0 4-1.8 4-4s-1.8-4-4-4ZM3.5 2C4.3 2 5 2.7 5 3.5S4.3 5 3.5 5 2 4.3 2 3.5 2.7 2 3.5 2Zm0 12c-.8 0-1.5-.7-1.5-1.5S2.7 11 3.5 11s1.5.7 1.5 1.5S4.3 14 3.5 14ZM6 10c-.5-.5-1.2-.9-2-1V6.9c.8-.1 1.5-.5 2-1L8.1 7c-.1.7-.1 1.3 0 1.9L6 10Zm6 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                  <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                    <h1
                                      data-nc="true"
                                      data-testid="header-name"
                                      className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                    >
                                      General
                                    </h1>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                            >
                              /
                            </span>
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 fBNEaG">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <div className="truncate__FlexClear-sc-11ftd2c-0 cOfaSa">
                                  <div className="truncate__TruncateWrapper-sc-11ftd2c-1 TTnYY">
                                    <h1
                                      data-nc="true"
                                      data-testid="header-name"
                                      className="heading__StyledHeading-sc-114dp0l-0 eDOqEr"
                                    >
                                      Feature boards
                                    </h1>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <span
                              data-nc="true"
                              className="textstyled__StyledText-sc-cx1866-0 eyQANm"
                            >
                              /
                            </span>
                          </div>
                          <div className="renamable-title__Container-sc-1our1fr-0 ccjVcs">
                            <div className="editable-textstyled__StyledEditableText-sc-1r26pyp-0 hEcAMv">
                              <div
                                data-nc="true"
                                className="textstyled__StyledText-sc-cx1866-0 hWldxC"
                              >
                                <div className="editable-textstyled__StyledHiddenLabel-sc-1r26pyp-1 cOlZlT">
                                  <div className="editable-textstyled__StyledHiddenLabelInner-sc-1r26pyp-2 kCXWkG">
                                    <div className="truncate__TruncateWrapper-sc-11ftd2c-1 caVNcG">
                                      Feature planning (sample)
                                    </div>
                                  </div>
                                </div>
                                <div className="editable-textstyled__StyledAbsolute-sc-1r26pyp-3 cOwQwL">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <input
                                      data-testid="EditableBoardTitle"
                                      className="editable-textstyled__StyledEditableTextInput-sc-1r26pyp-4 iWIqyJ"
                                      defaultValue="Feature planning (sample)"
                                      style={{ width: 197 }}
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="favorite-container__Container-sc-19nndzy-0 cGskpP">
                        <div className="favorite-container__FavoriteContainerStyled-sc-19nndzy-1 fcwIws">
                          <div>
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="StarIcon"
                                className="sc-11y93t1-0 xIpMQ ui-icon"
                              >
                                <g clipPath="url(#Star_svg__a)">
                                  <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="m8.467 11.11 2.531 1.331-.482-2.82a1 1 0 0 1 .287-.885l2.048-1.998-2.83-.41a.996.996 0 0 1-.753-.548L8 3.214 6.734 5.78a1 1 0 0 1-.753.547l-2.831.411 2.049 1.998a1 1 0 0 1 .287.885l-.483 2.82 2.532-1.33a.998.998 0 0 1 .932 0zm3.393 4.044L8 13.125l-3.86 2.03c-.726.386-1.591-.236-1.45-1.055l.737-4.299L.303 6.757a1 1 0 0 1 .555-1.706l4.316-.627L7.104.512c.337-.683 1.458-.683 1.794 0l1.93 3.911 4.317.627a1.001 1.001 0 0 1 .555 1.706l-3.124 3.045.736 4.3c.142.822-.726 1.435-1.451 1.053z"
                                    clipRule="evenodd"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="Star_svg__a">
                                    <path fill="#fff" d="M0 0h16v16H0z" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 wctrz">
                  <VeltHuddleTool/>

                    <div
                      data-search-field-loading="false"
                      data-nc="true"
                      className="text-field-primitivestyled__Wrapper-sc-1ndan3b-0 fplKzA"
                    >

                      <div className="text-field-primitivestyled__Field-sc-1ndan3b-3 gHGzqM">

                        <span className="text-field-primitivestyled__IconWrapper-sc-1ndan3b-1 dUAWyH">
                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 gNNPTr">
                            <svg
                              height="16px"
                              width="16px"
                              viewBox="0 0 16 16"
                              role="img"
                              aria-label="SearchIcon"
                              className="sc-11y93t1-0 xIpMQ ui-icon"
                              data-testid="Header-SearcField-SearchIcon"
                            >
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                d="M15.546 15.546a1.5 1.5 0 0 1-2.121 0l-2.647-2.647a6.945 6.945 0 0 1-3.763 1.115 7 7 0 0 1 0-13.999 6.998 6.998 0 0 1 6.999 6.999 6.953 6.953 0 0 1-1.114 3.764l2.647 2.648a1.5 1.5 0 0 1-.001 2.12zM7.014 2.014a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                        </span>
                        <input
                          type="search"
                          placeholder="Search..."
                          autoComplete="off"
                          data-testid="Header-SearcField"
                          data-search-field-loading="false"
                          className="text-field-primitivestyled__StyledTextField-sc-1ndan3b-6 gbzXRE"
                          defaultValue=""
                        />
                      </div>
                    </div>
                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                      <button
                        type="button"
                        data-nc="true"
                        data-testid="Header-ShareButton"
                        className="button-primitive__StyledButton-sc-1guvopt-0 dcewKt"
                      >
                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="ShareIcon"
                            className="sc-11y93t1-0 dqXaRM ui-icon"
                          >
                            <path
                              d="M1 16h14c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-3v2h2v7H2V7h2V5H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1Z"
                              fill="currentColor"
                            />
                            <path
                              d="M7.61 11a.6.6 0 0 1-.6-.6V4H5.086c-.525 0-.794-.6-.43-.96L7.56.174a.618.618 0 0 1 .86 0l2.9 2.866c.364.36.096.96-.43.96H9.01v6.4a.6.6 0 0 1-.6.6h-.8Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                          <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                            Share
                          </span>
                        </span>
                      </button>
                    </span>
                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                      <button
                        type="button"
                        aria-label="Show more"
                        data-nc="true"
                        data-testid="Header-ContextMenu"
                        className="button-primitive__StyledButton-sc-1guvopt-0 eAkUBH"
                      >
                        <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="DotsIcon"
                            className="sc-11y93t1-0 dqXaRM ui-icon"
                          >
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="header-secondary__Container-sc-wrzcoj-1 jjoxBj">
                  <div className="header-secondary__RelativeShift-sc-wrzcoj-0 iXlKLl">
                    <div className="header-secondary__ScrollableContainer-sc-wrzcoj-2 hdDHBa">
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                          <div className="kYtWvAzVL_GijpxOOJwF">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <span
                                className="UbyxfkCOwd0QZ6bPUFCA E_01Y9hYQrLNdc4jjOxz"
                                data-testid="BoardGrouping-Container"
                              >
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="grouping-button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="DuplicateIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M15 0H7c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 8H8V2h6v6zm-6 6H2V8h2V6H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-3H8v2z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      Grouped by: Release
                                    </span>
                                  </span>
                                </button>
                              </span>
                            </span>
                          </div>
                        </span>
                        <div className="board-filter-wrapperstyled__BoardFilterWrapper-sc-texokw-0 cYrnhR">
                          <div className="sc-1i3qtnn-0 kxgOFp">
                            <div
                              data-testid="BoardFilter-Filters-Icon"
                              className="sc-1i3qtnn-1 hXSezE"
                            >
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  aria-label="Filter"
                                  data-nc="true"
                                  data-testid="filter-button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 ksTnjT"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="FilterIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        d="M15 1H1v2h14V1zm-3 4H4v2h8V5zM6 9h4v2H6V9zm3 4H7v2h2v-2z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 eXegLi">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      Filter
                                    </span>
                                  </span>
                                </button>
                              </span>
                              <div className="vu1IPbL1H8l1P3jRxAIV">
                                <div className="f5VSbGks1i8DxdDJ324f">
                                  <div
                                    className="T38TAHfZiSXZ3g792lHy QpwL7Zf7Rkfx5pd82gGz b9vFPwdzsj0M366THDp0"
                                    style={{ display: "none" }}
                                  >
                                    <span>+0</span>
                                    <div className="iTRjKj3YSDJ_uYHjNMJh pFc6ScbH9FPqyP6_nk1V" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 jJmdFf" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-layout__Content-sc-1u3l193-0 dnCWBw">
                <div
                  className="ylTMo5EH3cF8l80h46UG"
                  data-testid="FeaturesBoard-FloatingPlus-Wrapper"
                >
                  <div>
                    <div className="floating-actionstyled__StyledWrapper-sc-4rigmj-1 jrhhRX">
                      <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 OfgtE">
                        <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                          <button
                            type="button"
                            data-nc="true"
                            data-testid="FloatingAction-main"
                            className="button-primitive__StyledButton-sc-1guvopt-0 eFtOQb"
                          >
                            <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                              <svg
                                height="16px"
                                width="16px"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="PlusIcon"
                                className="sc-11y93t1-0 dqXaRM ui-icon"
                              >
                                <path
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  d="M9 7V3a.999.999 0 1 0-1.999 0v4H3a1 1 0 1 0 0 2h4.001v4A1 1 0 1 0 9 13V9h4.001a1 1 0 0 0 0-2H9z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </button>
                        </span>
                      </div>
                      <div className="floating-actionstyled__StyledMenu-sc-4rigmj-0 fFjTAz">
                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 kxzJUm">
                          <div className="floating-actionstyled__StyledAnimateButton-sc-4rigmj-2 csFoYv">
                            <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 jOrLda">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="FloatingAction-action"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 fnTnVj"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="ReleaseIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <g fill="currentColor">
                                        <path d="M0 15a1 1 0 1 0 2 0V1a1 1 0 0 0-2 0v14z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M15.793 1.588A.95.95 0 0 0 16 1c0-.552-.484-1-1.08-1H5.16C3.967 0 3 .895 3 2v7c0 1.105.967 2 2.16 2h9.76c.228 0 .45-.067.635-.191.483-.325.59-.95.238-1.397L13 5.5l2.793-3.912zM10.543 5.5l2.5-3.5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.042l-2.5-3.5z"
                                          clipRule="evenodd"
                                        />
                                      </g>
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                          </div>
                          <div className="floating-actionstyled__StyledAnimateButton-sc-4rigmj-2 csFoZc">
                            <div className="button-floating__StyledButtonWrapper-sc-1j4hk0u-0 jOrLda">
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="FloatingAction-action"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 fnTnVj"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="ImportIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.998 14.999a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5.999h11.998V8a1 1 0 0 1 2 0v6.999Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M7.598 0a.6.6 0 0 0-.6.6V7H5.074c-.526 0-.794.6-.43.96l2.903 2.866a.618.618 0 0 0 .86 0l2.902-2.866c.364-.36.096-.96-.43-.96H8.998V.6a.6.6 0 0 0-.6-.6h-.8Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="VG3B4_4N4ejtcDTLKvGT ErZK3BlrK1lPnstkGDr_ CNtCrafaipgpEwtZ015M"
                  data-testid="FeaturesBoard-Container"
                >
                  <div className="DkhFZNfCrTa28bLL4ZY5">
                    <div className="GvaGmKB2XC9NGpLOqgyF">
                      <div className="VmnY2JClBtVTkI6ClPVq oKME8LxHC7nO4aM7GvO8">
                        <div
                          className="YJAHTe6a8sKX8IH1iK19"
                          style={{ width: 600 }}
                        >
                          <div className="ogWobSoSmnwIns9OtdIG">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <button
                                type="button"
                                aria-label="Add columns"
                                data-nc="true"
                                data-testid="FeatureBoard-AddColumns-Button"
                                className="button-primitive__StyledButton-sc-1guvopt-0 jUqlUi"
                              >
                                <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ColumnsAddIcon"
                                    className="sc-11y93t1-0 dqXaRM ui-icon"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M5 3H3v10h2V3ZM3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M11 10a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M14 11a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4ZM11 3h2v5a1 1 0 1 0 2 0V3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v5a1 1 0 0 0 2 0V3Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </span>
                          </div>
                          <div className="FzehqZnns5XbNYbKcx_w fCnjdqs5OAyKrSb4c7gv">
                            <div className="feature-import-banner-inline-column-editingstyled__MainContainer-sc-1lfubw7-2 jNeZqy">
                              <div className="feature-import-banner-inline-column-editingstyled__CloseButtonWrapper-sc-1lfubw7-1 huYkhh">
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="RemoveIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M8 6.441 4.882 3.323a1.101 1.101 0 1 0-1.558 1.559L6.442 8l-3.119 3.118a1.102 1.102 0 1 0 1.559 1.56l3.119-3.12 3.118 3.119a1.102 1.102 0 1 0 1.558-1.559L9.559 8l3.119-3.118a1.102 1.102 0 0 0-1.56-1.56L8 6.443z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 hMrgZ">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                  <img
                                    src="https://cdn.productboard.com/assets/63d8c62edb5b717247ab.png"
                                    alt=""
                                    className="feature-import-banner-inline-column-editingstyled__Illustration-sc-1lfubw7-3 fyexpV"
                                  />
                                </div>
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                  <div className="feature-import-banner-inline-column-editingstyled__TextContent-sc-1lfubw7-4 hISGui">
                                    <div className="feature-import-banner-inline-column-editingstyled__BannerHeading-sc-1lfubw7-0 JUxrn">
                                      <div
                                        data-nc="true"
                                        className="heading__StyledHeading-sc-114dp0l-0 bckMDB"
                                      >
                                        Already have a backlog?
                                      </div>
                                    </div>
                                    <p
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 dlYLYb"
                                    >
                                      Import feature ideas easily from your
                                      favorite tools
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="vGc5KWhc9GuNHYWEqieG"
                          data-testid="FeaturesBoard-ColumnSectionWrapper"
                          style={{
                            transform: "translate3d(0px, 0px, 0px)",
                            width: 658
                          }}
                        >
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508892"
                            style={{ width: 96, left: 0 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <span className="hkoxfXQcfykztTpZj62o CZvDKpQt0KXVUoUukLFA" />
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588887"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588887 owner columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 96, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Owner
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508907"
                            style={{ width: 214, left: 96 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <span className="hkoxfXQcfykztTpZj62o CZvDKpQt0KXVUoUukLFA" />
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588939"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588939 timeframe columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 214, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Timeframe
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="UkZ4wEvo2xJ1SGxcd7pb columnGroupHeader column-group-id-7508884"
                            style={{ width: 348, left: 310 }}
                          >
                            <div
                              className="owUJiLemkSITc6Jsauyc"
                              data-testid="FeaturesBoard-ColumnGroupHeader-Wrapper"
                            >
                              <button className="sc-1wmv0qx-1 dpJjBh">
                                <span
                                  data-nc="true"
                                  className="textstyled__StyledText-sc-cx1866-0 blXKZm"
                                >
                                  Tasks
                                </span>
                                <div className="sc-1wmv0qx-0 ibVmVZ">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="ArrowCaretIcon"
                                    className="sc-11y93t1-0 kqDcRj ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M5.25 7.495C4.75 6.997 5 6 6 6h3.995c1.005 0 1.256.995.755 1.495l-2 2.205c-.45.4-1.05.4-1.498 0L5.25 7.495z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </button>
                            </div>
                            <div className="U9LfFkFGd_EURohehsmp">
                              <div
                                id="column-header-60588891"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588891 task columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 116, left: 0 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Product Spec
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                              <div
                                id="column-header-60588889"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588889 task columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 116, left: 116 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Design Assets
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                              <div
                                id="column-header-60588903"
                                className="cbpBwGzp2L6M7DK5SE7g column-id-60588903 task columnHeader columnHeaderWithMenu"
                                data-testid="FeaturesBoard-ColumnHeader"
                                style={{ width: 116, left: 232 }}
                              >
                                <div className="s5TxIOWIrqsLmcIZxbWE">
                                  <span className="WItSUw_APpc184QRxRy_">
                                    <span className="otvfkBpiZP6Km7fdHZEQ">
                                      Launch Ready
                                    </span>
                                  </span>
                                </div>
                                <div className="column-menu__FilterWrapper-sc-mh3zb-0 hACabW">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      data-testid="FeaturesBoard-ColumnFilter-ArrowContainer"
                                      className="column-menu-button__MenuButton-sc-4d4qse-0 erGYog"
                                    >
                                      <svg
                                        height="12px"
                                        width="12px"
                                        viewBox="0 0 16 16"
                                        role="img"
                                        aria-label="DotsIcon"
                                        className="sc-11y93t1-0 kqDcRj ui-icon"
                                      >
                                        <path
                                          fill="currentColor"
                                          fillRule="evenodd"
                                          d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                                <div
                                  className="LQaauXTd4g76IzJ929Ob"
                                  data-testid="ColumnFilterContainer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="YTMpFgNm73jhqHP2SZoc"
                      style={{ position: "relative" }}
                    >
                      <div className="PErwaA01Evv3LcPYu08a">
                        <div
                          id="board-content-scrollable"
                          className="e9daayaM3ttdq9eeku8L"
                          style={{ height: 609 }}
                        >
                          <div className="Yq6w5Hj3EyeQDOgLNRVn cAjUk9R1Q0h6dkUOpIiO">
                            <div className="djltbc7b1dng7rc79ur6" />
                            <div
                              className="LDjKwCEV9BMsiRj0h4ke"
                              style={{ height: 160 }}
                            >
                              <div
                                className="i79VdW0TOO35s6Cjcjkk"
                                style={{ width: 600 }}
                              >
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 120px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks fv8EdGx2kAuBHCTk8tIw">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          className="TmmXjAETbbMouL8IAKDW"
                                          data-testid="FeaturesBoard-QuickAddTopLevel-Section"
                                        >
                                          <svg
                                            viewBox="0 0 16 16"
                                            className="d4YepzgP4Fg1HL37LKoH oMiYLvQo1yWeDHfp87d2 pb-icon"
                                          >
                                            <path d="M8 .001A8 8 0 108 16 8 8 0 008 0zm0 13.998c-3.308 0-5.999-2.691-5.999-5.999S4.692 2.001 8 2.001c3.309 0 6 2.691 6 5.999s-2.691 5.999-6 5.999zM11.01 7H9V4.99A.99.99 0 008.01 4h-.02a.99.99 0 00-.99.99V7H4.991A.99.99 0 004 7.99v.02c0 .548.444.99.991.99H7v2.01c0 .547.443.989.99.989h.02c.547 0 .99-.442.99-.989V9h2.01a.99.99 0 00.99-.99v-.02a.99.99 0 00-.99-.99z" />
                                          </svg>
                                          <span className="laO7VtVMWVolUtBiX8Xb">
                                            Add new release
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 80px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 52 }}
                                            >
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9 toggle-icons--is-collapsed"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Collapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <span>
                                                  <svg
                                                    viewBox="0 0 16 16"
                                                    className="VD5WUYRyCIijpC5L0KZC oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                    data-testid="Card-Icon"
                                                  >
                                                    <path d="M1 16c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
                                                    <path
                                                      d="M5.2 0H15c.5 0 1 .4 1 1 0 .2-.1.4-.2.6l-3.1 3.9 3.1 3.9c.4.4.2 1.1-.2 1.4-.2.1-.4.2-.6.2H5.2C4 11 3 10.1 3 9V2C3 .9 4 0 5.2 0z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </span>
                                              </div>
                                            </div>
                                            <div className="FceG8Z_9tHBcXeYC6xyG xC1qSemCbaxIHEtwsMZO">
                                              <span className="Nq9AmJoJXi8lN7fDSa3L">
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  No release set
                                                </span>
                                              </span>
                                            </div>
                                            <div className="hhiYAcM81cnhxkhXX2Pm">
                                              <div />
                                              <div className="rPTF0p1VAzV7qTkVVBJg" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 0px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF active">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9 Ee17_0sarkdQLH7o9uGv">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 52 }}
                                            >
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9 toggle-icons--is-collapsed"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Collapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <div className="F4jfOCaX31hQbsb5cjBE VD5WUYRyCIijpC5L0KZC">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <span>
                                                      <span>
                                                        <svg
                                                          viewBox="0 0 16 16"
                                                          className="pb-release-state in-progress QW_EwT70N9f2971AZsHY erqN6yobEySMlak5eNnP oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                          data-testid="pb-release-state"
                                                        >
                                                          <path d="M1 16c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
                                                          <path
                                                            d="M5.2 0H15c.5 0 1 .4 1 1 0 .2-.1.4-.2.6l-3.1 3.9 3.1 3.9c.4.4.2 1.1-.2 1.4-.2.1-.4.2-.6.2H5.2C4 11 3 10.1 3 9V2C3 .9 4 0 5.2 0z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </span>
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="FceG8Z_9tHBcXeYC6xyG xC1qSemCbaxIHEtwsMZO TUHHEueWsY63UAzvEJ_M">
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L WclikVGZK_xDobob5BM_"
                                                draggable="false"
                                                href="/feature-board/7450405-feature-planning-sample"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Sprint 1
                                                </span>
                                              </a>
                                            </div>
                                            <div className="hhiYAcM81cnhxkhXX2Pm">
                                              <div />
                                              <div className="rPTF0p1VAzV7qTkVVBJg" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 40px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div
                                      className="pIGHIH2k33OB1cV2jNAF"
                                      style={{ paddingLeft: 0 }}
                                    >
                                      <div className="VfAv95lDdjDXN6LpVEIz lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                        <div
                                          data-testid="DraggableCanvasElement"
                                          style={{
                                            display: "flex",
                                            width: "100%"
                                          }}
                                        >
                                          <div className="lMYiaxEEatguUeYOeeAc tRv3BP4B1YVJ_wyCevMz">
                                            <div
                                              className="OZEMH4mCtKdrSk6JTcc9"
                                              style={{ width: 52 }}
                                            >
                                              <div style={{ width: 26 }}>
                                                <div
                                                  className="toggle-icons nShXrmNDePDgKtZR4OE9 toggle-icons--is-collapsed"
                                                  data-testid="FeaturesBoard-RowExpansionToggle-Collapsed"
                                                >
                                                  <svg
                                                    viewBox="0 0 10 6"
                                                    className="oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      clipRule="evenodd"
                                                      d="M4.205 5.682L.308 1.851a1.07 1.07 0 010-1.533 1.115 1.115 0 011.558 0l3.118 3.065L8.102.318a1.117 1.117 0 011.56 0c.43.423.43 1.11 0 1.533L5.764 5.682a1.116 1.116 0 01-1.559 0z"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div style={{ width: 26 }}>
                                                <div className="F4jfOCaX31hQbsb5cjBE VD5WUYRyCIijpC5L0KZC">
                                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                    <span>
                                                      <span>
                                                        <svg
                                                          viewBox="0 0 16 16"
                                                          className="pb-release-state upcoming QW_EwT70N9f2971AZsHY erqN6yobEySMlak5eNnP oMiYLvQo1yWeDHfp87d2 pb-icon"
                                                          data-testid="pb-release-state"
                                                        >
                                                          <path d="M1 16c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
                                                          <path
                                                            d="M5.2 0H15c.5 0 1 .4 1 1 0 .2-.1.4-.2.6l-3.1 3.9 3.1 3.9c.4.4.2 1.1-.2 1.4-.2.1-.4.2-.6.2H5.2C4 11 3 10.1 3 9V2C3 .9 4 0 5.2 0z"
                                                            fill="currentColor"
                                                          />
                                                        </svg>
                                                      </span>
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="FceG8Z_9tHBcXeYC6xyG xC1qSemCbaxIHEtwsMZO TUHHEueWsY63UAzvEJ_M">
                                              <a
                                                className="t5jTNpP6pQB0K8JLPt15 Nq9AmJoJXi8lN7fDSa3L"
                                                draggable="false"
                                                href="/feature-board/7450405-feature-planning-sample/releases/1416947"
                                              >
                                                <span className="s0c4fLqv8QRGYgMjE0Tm">
                                                  Sprint 2
                                                </span>
                                              </a>
                                            </div>
                                            <div className="hhiYAcM81cnhxkhXX2Pm">
                                              <div />
                                              <div className="rPTF0p1VAzV7qTkVVBJg" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="E1cl9ZdQjNJgZ75A27av"
                                data-testid="FeaturesBoard-LazyRender-ColumnGroupSection"
                                style={{
                                  left: 600,
                                  transform: "translate3d(0px, 0px, 0px)",
                                  width: 940
                                }}
                              >
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 120px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks fv8EdGx2kAuBHCTk8tIw">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl"
                                        style={{ width: 658 }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 0px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF active">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9 Ee17_0sarkdQLH7o9uGv">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl"
                                        style={{ width: 658 }}
                                      >
                                        <div
                                          className="group column-group-id-7508892"
                                          style={{
                                            position: "absolute",
                                            width: 96,
                                            height: "100%",
                                            left: 0
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588887 owner"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 96
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            position: "absolute",
                                            width: 214,
                                            height: "100%",
                                            left: 96
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588939 timeframe"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 214
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508884"
                                          style={{
                                            position: "absolute",
                                            width: 348,
                                            height: "100%",
                                            left: 310
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588891 task"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588889 task"
                                            style={{
                                              position: "absolute",
                                              left: 116,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588903 task"
                                            style={{
                                              position: "absolute",
                                              left: 232,
                                              width: 116
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 80px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF qrIsn7rzNPE5XXPGC4ks">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl"
                                        style={{ width: 658 }}
                                      >
                                        <div
                                          className="group column-group-id-7508892"
                                          style={{
                                            position: "absolute",
                                            width: 96,
                                            height: "100%",
                                            left: 0
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588887 owner"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 96
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            position: "absolute",
                                            width: 214,
                                            height: "100%",
                                            left: 96
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588939 timeframe"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 214
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508884"
                                          style={{
                                            position: "absolute",
                                            width: 348,
                                            height: "100%",
                                            left: 310
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588891 task"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588889 task"
                                            style={{
                                              position: "absolute",
                                              left: 116,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588903 task"
                                            style={{
                                              position: "absolute",
                                              left: 232,
                                              width: 116
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="RqcotRev5X80W3mvKzeu"
                                  data-testid="FeaturesBoard-LazyRenderRow"
                                  style={{
                                    height: 40,
                                    transform: "translate3d(0px, 40px, 0px)",
                                    transition: "transform 0.2s ease 0s"
                                  }}
                                >
                                  <div className="boardRow nI2ByKENsyAJMeemLxgF">
                                    <div className="zs1cVkpvgeZb7feMhxVJ lEKJqtjn1cVuzmzLtCym X7GJUQxvxJp0sLemrdI9">
                                      <div
                                        className="LesxKFh3HmlgZIEt7tJl"
                                        style={{ width: 658 }}
                                      >
                                        <div
                                          className="group column-group-id-7508892"
                                          style={{
                                            position: "absolute",
                                            width: 96,
                                            height: "100%",
                                            left: 0
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588887 owner"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 96
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508907"
                                          style={{
                                            position: "absolute",
                                            width: 214,
                                            height: "100%",
                                            left: 96
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588939 timeframe"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 214
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="group column-group-id-7508884"
                                          style={{
                                            position: "absolute",
                                            width: 348,
                                            height: "100%",
                                            left: 310
                                          }}
                                        >
                                          <div
                                            className="cell column-id-60588891 task"
                                            style={{
                                              position: "absolute",
                                              left: 0,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588889 task"
                                            style={{
                                              position: "absolute",
                                              left: 116,
                                              width: 116
                                            }}
                                          />
                                          <div
                                            className="cell column-id-60588903 task"
                                            style={{
                                              position: "absolute",
                                              left: 232,
                                              width: 116
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="H55jh5YCAb9uSVrao9Fq"
                              style={{
                                height: "100%",
                                left: 600,
                                transform: "translate3d(0px, 0px, 0px)"
                              }}
                            >
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508892"
                                style={{ left: 0, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508907"
                                style={{ left: 96, display: "block" }}
                              />
                              <div
                                className="gPXF0Bod4goR4xYad1tw column-group-id-7508884"
                                style={{ left: 310, display: "block" }}
                              />
                            </div>
                            <div className="QvBpcxid9PXlip8YiQDJ" />
                            <div id="visualization-portal" />
                            <div
                              className="ehk4JteljVmJ67dSNIYl"
                              style={{
                                transform: "translate3d(600px, 0px, 0px)"
                              }}
                            />
                            <div style={{ height: 150 }} />
                          </div>
                        </div>
                      </div>
                      <div
                        className="DYUadK9NU0sQZ8Vyku9y"
                        style={{ transform: "translate3d(600px, 0px, 0px)" }}
                      >
                        <div className="hIIoOL4prkZlPxYCDT8O">
                          <div style={{ position: "relative", width: 656 }}>
                            <div className="horizontal-scrollbarstyled__ScrollbarArea-sc-1uwgsfu-0 hsaLeN">
                              <div
                                className="horizontal-scrollbarstyled__Scrollbar-sc-1uwgsfu-1 iVNUxr"
                                style={{ left: 0, width: "69.5279%" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="sc-yk0mva-1 hueKlo"
                      style={{ transform: "translate3d(600px, 0px, 0px)" }}
                    />
                    <div
                      data-testid="DraggableCanvasElement"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        zIndex: 2
                      }}
                    >
                      <div
                        className="sc-yk0mva-2 aEkbR"
                        style={{ transform: "translate3d(600px, 0px, 0px)" }}
                      >
                        <div className="sc-yk0mva-0 kxSyrl" />
                      </div>
                    </div>
                    <div className="sc-yk0mva-3 jTAuVT" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="l7B6cTdN4Oeh97u6z6DD">
            <div className="Ozo6oRe_fNOmKphyaKBS">
              <div className="D1K3Q48lGpHbhbZNSVCQ">
                <div className="sc-16wh4vb-0 hAVASv">
                  <div className="sc-16wh4vb-0 hAVASv">
                    <div
                      data-testid="SidebarContainer"
                      className="Cvur3kjv1Ir98acRp7yu"
                    >
                      <div className="p7y7hUGaKQEsgBej5ZwO">
                        <a
                          data-testid="Sidebar-BackLink"
                          className="u7oZDVa4Efd2rcALAEaw"
                          href="/feature-board/7450405-feature-planning-sample/releases/1416947"
                        >
                          <svg
                            height="16px"
                            width="16px"
                            viewBox="0 0 16 16"
                            role="img"
                            aria-label="ChevronLeftIcon"
                            className="sc-11y93t1-0 xIpMQ ui-icon"
                          >
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M5.318 7.221 9.15 3.324a1.07 1.07 0 0 1 1.533 0c.423.43.423 1.128 0 1.558L7.617 8l3.065 3.118a1.117 1.117 0 0 1 0 1.56c-.423.43-1.11.43-1.533 0L5.32 8.78a1.116 1.116 0 0 1 0-1.559z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </a>
                        <div className="MA4J74V8zIPXGSRAr0kX G28wVquC_pbyOydlvOhC">
                          <div className="F4jfOCaX31hQbsb5cjBE">
                            <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                              <span>
                                <span>
                                  <svg
                                    viewBox="0 0 16 16"
                                    className="pb-release-state in-progress QW_EwT70N9f2971AZsHY erqN6yobEySMlak5eNnP oMiYLvQo1yWeDHfp87d2 pb-icon"
                                    data-testid="pb-release-state"
                                  >
                                    <path d="M1 16c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v14c0 .6-.4 1-1 1z" />
                                    <path
                                      d="M5.2 0H15c.5 0 1 .4 1 1 0 .2-.1.4-.2.6l-3.1 3.9 3.1 3.9c.4.4.2 1.1-.2 1.4-.2.1-.4.2-.6.2H5.2C4 11 3 10.1 3 9V2C3 .9 4 0 5.2 0z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="editable-headingstyled__Wrapper-sc-2wi4o3-1 kMqldN">
                          <div className="box__StyledBox-sc-b30x7m-0 btJnBg">
                            <div
                              data-nc="true"
                              className="heading__StyledHeading-sc-114dp0l-0 hKVaJD"
                            >
                              <textarea
                                placeholder="Release name"
                                rows={1}
                                data-testid="DetailTitleTextArea-Input"
                                className="editable-headingstyled__Textarea-sc-2wi4o3-0 isXUAp"
                                defaultValue={"Sprint 1"}
                              />
                              <div
                                aria-hidden="true"
                                data-testid="DetailTitleTextArea-Input-Text"
                                className="editable-headingstyled__PlaceholderText-sc-2wi4o3-2 dsQcOl"
                              >
                                Sprint 1
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ly5DNNkxj7f67rq9h7Xo">
                          <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 iDRXau">
                              <div
                                data-testid="Column-Toggle"
                                className="switchstyled__Wrapper-sc-msfgbt-0 iDAvBG"
                              >
                                <input
                                  id={60588936}
                                  type="checkbox"
                                  data-testid="UiSwitchToggle-Checked"
                                  className="switchstyled__Input-sc-msfgbt-2 cetTRk"
                                  defaultChecked=""
                                />
                                <label
                                  htmlFor={60588936}
                                  className="switchstyled__Label-sc-msfgbt-1 cqEwOY"
                                />
                              </div>
                            </div>
                          </span>
                          <div id="1416946-context-menu">
                            <div
                              className="wFAYU_4jv_JeUWUO4F8P"
                              data-testid="ContextMenu-Container"
                            >
                              <div className="rFjCbk3y2wTOfO8gQiU8">
                                <svg
                                  viewBox="0 6 16 4"
                                  className="VQQOOss_ILXbEkac9_o5 Prgg4WwEQrVn4tFum_sK oMiYLvQo1yWeDHfp87d2 pb-icon"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2 6a2 2 0 100 3.998A2 2 0 002 6zm6 0a2 2 0 100 4 2 2 0 000-4zm5.999 0a2 2 0 100 4 2 2 0 000-4z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="KAhoJQAYoeilhr75NJrw">
                        <div id="sidebar-wrapper-portal" />
                        <div
                          id="sidebar-wrapper"
                          className="Yw11KRsFu2j8x3ibIe8Y"
                        >
                          <div
                            id="sidebar-scrollable"
                            className="LqVZ4B8vUjF1VEuLyLCA"
                          >

                            <div className="sc-1vo99k0-0 qJoEe">
                              <div className="expand-fullscreen-editor-iconstyled__Wrapper-sc-ucnh8t-0 bKxgiQ">
                                <div className="expand-fullscreen-editor-iconstyled__IconWrapper-sc-ucnh8t-1 hBkGYk">
                                  <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                    <button
                                      type="button"
                                      aria-label="Expand editor to fullscreen"
                                      data-nc="true"
                                      className="button-primitive__StyledButton-sc-1guvopt-0 bXabpB"
                                    >
                                      <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                        <svg
                                          height="16px"
                                          width="16px"
                                          viewBox="0 0 16 16"
                                          role="img"
                                          aria-label="ExpandToModalIcon"
                                          className="sc-11y93t1-0 dqXaRM ui-icon"
                                        >
                                          <path
                                            d="M13.004 4.676 9.517 8 8.003 6.486 11.328 3H8V1h7.003v6.998h-1.999V4.676zM3 11.324 6.485 8 8 9.514 4.676 13h3.327v2H1V8.002h2v3.322z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </div>
                                    </button>
                                  </span>
                                </div>
                              </div>
                              <div>
                                <div
                                  role="textbox"
                                  aria-multiline="true"
                                  className="sc-1vo99k0-1 hcNFog notranslate"
                                  data-gramm="true"
                                  data-focused="true"
                                  data-perf="SidebarEditor-Input"
                                  data-slate-editor="true"
                                  data-slate-node="value"
                                  contentEditable="true"
                                  zindex={-1}
                                  style={{
                                    position: "relative",
                                    outline: "none",
                                    whiteSpace: "pre-wrap",
                                    overflowWrap: "break-word"
                                  }}
                                >
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          This is a sample release.
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="n"
                                          data-slate-length={0}
                                        >
                                          ﻿<br />
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          Releases are for planning when new
                                          functionality will be available.
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="n"
                                          data-slate-length={0}
                                        >
                                          ﻿<br />
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          They can be used for your team's
                                          internal planning, or they can
                                          represent broader time horizons you'd
                                          like to display on your Roadmap.
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="n"
                                          data-slate-length={0}
                                        >
                                          ﻿<br />
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          Name releases according to your team's
                                          conventions:
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <ul
                                    data-slate-node="element"
                                    className="sc-14dyatu-0 pRueu"
                                  >
                                    <li
                                      data-slate-node="element"
                                      className="sc-dh8r5t-0 hKtict"
                                    >
                                      <p
                                        data-slate-node="element"
                                        className="sc-n1acgb-0 kBMOHo"
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-1akazgt-0 cVkWQE"
                                            style={{
                                              backgroundColor: "initial",
                                              fontStyle: "normal",
                                              fontWeight: 400,
                                              textDecoration: "none"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Discrete releases (e.g. R32, R33,
                                              R34)
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </li>
                                    <li
                                      data-slate-node="element"
                                      className="sc-dh8r5t-0 hKtict"
                                    >
                                      <p
                                        data-slate-node="element"
                                        className="sc-n1acgb-0 kBMOHo"
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-1akazgt-0 cVkWQE"
                                            style={{
                                              backgroundColor: "initial",
                                              fontStyle: "normal",
                                              fontWeight: 400,
                                              textDecoration: "none"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Broader time horizons (e.g. Q1,
                                              Q2, Q3)
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </li>
                                    <li
                                      data-slate-node="element"
                                      className="sc-dh8r5t-0 hKtict"
                                    >
                                      <p
                                        data-slate-node="element"
                                        className="sc-n1acgb-0 kBMOHo"
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-1akazgt-0 cVkWQE"
                                            style={{
                                              backgroundColor: "initial",
                                              fontStyle: "normal",
                                              fontWeight: 400,
                                              textDecoration: "none"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Relative time horizons (Now, Next,
                                              Later)
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </li>
                                    <li
                                      data-slate-node="element"
                                      className="sc-dh8r5t-0 hKtict"
                                    >
                                      <p
                                        data-slate-node="element"
                                        className="sc-n1acgb-0 kBMOHo"
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-1akazgt-0 cVkWQE"
                                            style={{
                                              backgroundColor: "initial",
                                              fontStyle: "normal",
                                              fontWeight: 400,
                                              textDecoration: "none"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Hybrid (e.g. March, April,
                                              Short-term, Long-term)
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </li>
                                  </ul>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="n"
                                          data-slate-length={0}
                                        >
                                          ﻿<br />
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          When releases represent discrete
                                          releases or milestones, you can update
                                          their status to{" "}
                                        </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        data-italic="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "italic",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          Upcoming
                                        </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">, </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        data-italic="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "italic",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          In progress
                                        </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          , and{" "}
                                        </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        data-italic="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "italic",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          Completed
                                        </span>
                                      </span>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span data-slate-string="true">
                                          , which can also be helpful for
                                          filtering them on and off your boards.
                                          Status may be less relevant for
                                          releases representing broad/relative
                                          time horizons.
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="n"
                                          data-slate-length={0}
                                        >
                                          ﻿<br />
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p
                                    data-slate-node="element"
                                    className="sc-n1acgb-0 kBMOHo"
                                  >
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="z"
                                          data-slate-length={0}
                                        >
                                          ﻿
                                        </span>
                                      </span>
                                    </span>
                                    <span
                                      data-slate-node="element"
                                      data-slate-inline="true"
                                      className="sc-7siq7c-0 dhDypo"
                                    >
                                      <a
                                        href="https://support.productboard.com/hc/en-us/articles/360058214113-Plan-releases-to-decide-what-to-deliver-when?_gl=1*jl488v*_ga*MTkzMTk1NTY2NC4xNzAwNTAyODEx*_ga_JSZ8NZ95N6*MTcwMDUwNTgyOS4yLjEuMTcwMDUwNTg0Ni40My4wLjA."
                                        rel="noreferrer noopener"
                                        target="_blank"
                                        className="sc-rag3yx-0 kDvZOZ"
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-1akazgt-0 cVkWQE"
                                            style={{
                                              backgroundColor: "initial",
                                              fontStyle: "normal",
                                              fontWeight: 400,
                                              textDecoration: "none"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Here's more info
                                            </span>
                                          </span>
                                        </span>
                                       
                                        
                                      </a>
                                    </span>
                                    <span data-slate-node="text">
                                      <span
                                        data-slate-leaf="true"
                                        className="sc-1akazgt-0 cVkWQE"
                                        style={{
                                          backgroundColor: "initial",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          textDecoration: "none"
                                        }}
                                      >
                                        <span
                                          data-slate-zero-width="z"
                                          data-slate-length={0}
                                        >
                                          ﻿
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                </div>
                                <div>
                                        {
                                        recordedData.map((data) => {
                                            return (
                                                // This is alternative way to render the recorded data
                                                // <div key={data.id} dangerouslySetInnerHTML={{ __html: data.tag }}></div>
                                                // STEP 5.c
                                                <div key={data.id}>
                                                    <VeltRecorderPlayer recorderId={data.id} />
                                                </div>
                                            )
                                        })
                                      } 
                                        </div>
                                <div className="sc-q0v2wk-0 lfFBIy">
                                  <div className="sc-q0v2wk-2 hvhqBy" />
                                  <div className="sc-q0v2wk-1 ewFYhE">
                                    
                                    <div className="sc-ke9o7w-0 kvWrrm">
                                    
                                    
                                   
                                      <div
                                        data-testid="toolbar-content"
                                        className="sc-1qo8o6p-0 dAzUlZ"
                                      >
                                        
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 hsqzYC">
                                        
                                          <VeltRecorderTool type="all" panelId="1"/>
                                          <div className="sc-1qo8o6p-1 biAtBq">
                                            <span
                                              data-testid="editor-toolbar-button-templates"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Templates
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="GuideIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  fillRule="evenodd"
                                                  d="M4 12h5v-2H4v2zm0-3h5V7H4v2zm8-6H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1.001 11h-9V5h8.999v9h.001zM15 0H3a1 1 0 0 0-1 1v1h12v12h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </span>
                                            <div className="sc-vtj8iu-0 dcuwZJ" />
                                            <span
                                              data-testid="editor-toolbar-button-heading-1"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Heading 1
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + Option + 1
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="Heading1Icon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  d="M8 14h2V2H8v5H2V2H0v12h2V9h6v5zm6.184 0H16V6h-1.485L12 8.53l.97 1.02 1.214-1.12V14z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-heading-2"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Heading 2
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + Option + 2
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="Heading2Icon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  d="M6 12h2V4H6v3.003H2V4H0v8h2V9h4v3zm4.174 0H16v-1.477h-3.157c2.008-1.489 3.099-2.659 3.099-4.006 0-1.572-1.3-2.517-2.96-2.517-1.079 0-2.228.402-2.982 1.288l.94 1.11c.522-.555 1.195-.91 2.077-.91.639 0 1.254.332 1.254 1.029 0 .969-.929 1.773-4.097 4.16V12z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                            <div className="sc-vtj8iu-0 dcuwZJ" />
                                            <span
                                              data-testid="editor-toolbar-button-bold"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Bold
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + B
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="TextBoldIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  fillRule="evenodd"
                                                  d="M9.51 13.996H3V2h6.313c2.284 0 3.453 1.457 3.453 3.058 0 1.492-.935 2.518-2.068 2.751C11.993 8.007 13 9.25 13 10.741c0 1.817-1.187 3.255-3.49 3.255zm-.755-7.23c.864 0 1.403-.485 1.403-1.259 0-.737-.54-1.259-1.403-1.259H5.554v2.518h3.201zm.108 4.982c.954 0 1.53-.503 1.53-1.367 0-.755-.54-1.367-1.53-1.367H5.554v2.734h3.31z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-italic"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Italic
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + I
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="TextItalicsIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  d="M6 2h6v2H9.777l-1.782 8H10v2H4v-2h2.223l1.782-8H6V2z"
                                                />
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-underline"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Underline
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + U
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="TextUnderlineIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  d="M3 1v7.48C3 11.153 4.628 13 8 13c3.373 0 5-1.847 5-4.52V1h-2v7.639C11 10.146 9.711 11 8 11s-3-.854-3-2.361V1H3zm11 15v-2H2v2h12z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-code"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Code
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + Shift + C
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="CodeIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  fillRule="evenodd"
                                                  d="M5.988 14.217c.087.088.175.088.262.088.35 0 .7-.263.875-.613l3.5-10.5c.175-.525-.088-.962-.525-1.137-.525-.175-.962.087-1.137.525l-3.5 10.5c-.175.525.087.962.525 1.137zm-2.1-2.8L1.263 8.792a.846.846 0 0 1 0-1.225l2.625-2.625 1.224 1.225L3.1 8.18l2.012 2.012-1.224 1.225zm8.225 0-1.226-1.225L12.9 8.18l-2.013-2.013 1.226-1.225 2.625 2.625c.35.35.35.875 0 1.225l-2.625 2.625z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </span>
                                            <div className="sc-vtj8iu-0 dcuwZJ" />
                                            <span
                                              data-testid="editor-toolbar-button-list_unordered"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Bulleted list
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  * Space
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="TextListIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  d="M3 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6 4h8.999V2H6v2zm8.999 5H6V7h8.999v2zm0 5H6v-2h8.999v2zM4.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-list_ordered"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Numbered list
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  1 Space
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="TextListOrderedIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  d="M2.652 5.002h.852V1H2.76L1.5 2.266l.486.51.666-.678v2.904zm3.348-3v2h8.999v-2H6zm8.999 7H6v-2h8.999v2zm0 5H6v-2h8.999v2zM1 14.38c.28.35.804.622 1.5.622.913 0 1.5-.47 1.5-1.138 0-.58-.502-.888-.89-.929.422-.075.833-.395.833-.882 0-.645-.548-1.051-1.437-1.051-.668 0-1.147.261-1.455.615l.405.517c.268-.261.6-.4.97-.4.393 0 .707.15.707.458 0 .285-.285.412-.707.412-.143 0-.405 0-.474-.005v.743a8.51 8.51 0 0 1 .474-.012c.53 0 .764.14.764.447 0 .29-.257.494-.719.494-.37 0-.787-.163-1.043-.442L1 14.381zm3-4.378H1.087V9.34c1.584-1.193 2.048-1.595 2.048-2.08 0-.348-.307-.514-.626-.514-.441 0-.778.178-1.039.455L1 6.646c.377-.443.952-.644 1.491-.644.83 0 1.48.473 1.48 1.258 0 .674-.545 1.259-1.55 2.003H4v.739z"
                                                  fill="currentColor"
                                                />
                                              </svg>
                                            </span>
                                            <div className="sc-vtj8iu-0 dcuwZJ" />
                                            <span
                                              data-testid="editor-toolbar-button-link"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 kqVyDT"
                                            >
                                              <div className="sc-pmqc9t-0 cWaPnd">
                                                <span
                                                  data-nc="true"
                                                  className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                >
                                                  Link
                                                </span>
                                                <span className="sc-nzvvjc-0 dCsVYd">
                                                  ⌘ + K
                                                </span>
                                              </div>
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="LinkIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <g fill="currentColor">
                                                  <path d="M11.868 9.289a.913.913 0 0 1-1.289 0l-.644-.645 3.867-3.866L11.224 2.2 7.357 6.066l-.645-.645a.91.91 0 0 1 0-1.288L10.579.267a.911.911 0 0 1 1.289 0l3.866 3.866a.912.912 0 0 1 0 1.288l-3.866 3.868z" />
                                                  <path d="M10.579 5.42a.913.913 0 0 1 0 1.29l-3.867 3.867a.911.911 0 0 1-1.289-1.288L9.29 5.42a.911.911 0 0 1 1.289 0z" />
                                                  <path d="M8.646 9.934 4.779 13.8l-2.578-2.578 3.866-3.867-.644-.644a.91.91 0 0 0-1.289 0L.267 10.577a.911.911 0 0 0 0 1.289l3.867 3.866a.913.913 0 0 0 1.289 0l3.867-3.866a.911.911 0 0 0 0-1.29l-.644-.642z" />
                                                </g>
                                              </svg>
                                            </span>
                                            <span
                                              data-testid="editor-toolbar-button-more_options"
                                              role="button"
                                              tabIndex={0}
                                              className="sc-nzvvjc-1 nFhsw"
                                            >
                                              <svg
                                                height="16px"
                                                width="16px"
                                                viewBox="0 0 16 16"
                                                role="img"
                                                aria-label="DotsIcon"
                                                className="sc-11y93t1-0 xIpMQ ui-icon"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  fillRule="evenodd"
                                                  d="M2 6a2 2 0 1 0 0 3.998A2 2 0 0 0 2 6zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.999 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </span>
                                            <div className="sc-16l37w9-0 dWfMAL">
                                              <span
                                                data-testid="editor-toolbar-button-divider"
                                                role="button"
                                                tabIndex={0}
                                                className="sc-nzvvjc-1 nFhsw"
                                              >
                                                <div className="sc-pmqc9t-0 cWaPnd">
                                                  <span
                                                    data-nc="true"
                                                    className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                  >
                                                    Horizontal line
                                                  </span>
                                                  <span className="sc-nzvvjc-0 dCsVYd">
                                                    --- Enter
                                                  </span>
                                                </div>
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="HorizontalLineIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    d="M14.125 8.875a.875.875 0 0 0 0-1.75H1.875a.875.875 0 1 0 0 1.75h12.25z"
                                                  />
                                                  <path
                                                    d="M13.5 2h-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0 8h-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
                                                    fill=""
                                                  />
                                                </svg>
                                              </span>
                                              <span
                                                data-testid="editor-toolbar-button-codeBlock"
                                                role="button"
                                                tabIndex={0}
                                                className="sc-nzvvjc-1 nFhsw"
                                              >
                                                <div className="sc-pmqc9t-0 cWaPnd">
                                                  <span
                                                    data-nc="true"
                                                    className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                  >
                                                    Code block
                                                  </span>
                                                  <span className="sc-nzvvjc-0 dCsVYd">
                                                    ⌘ + Option + Shift + C
                                                  </span>
                                                </div>
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="CodeBlockIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    fillRule="evenodd"
                                                    d="M4.617 8.305c-.052 0-.104 0-.156-.052a.52.52 0 0 1-.312-.675l2.078-6.234a.52.52 0 0 1 .675-.311.52.52 0 0 1 .312.675L5.136 7.94c-.104.208-.311.364-.52.364zM1.656 5.032l1.558 1.559.727-.728L2.747 4.67 3.94 3.474l-.727-.727-1.558 1.558a.502.502 0 0 0 0 .727zm5.714.831.727.728 1.558-1.559a.502.502 0 0 0 0-.727L8.097 2.747l-.727.727 1.194 1.195L7.37 5.863zm4.38-2.113a.75.75 0 0 0 0 1.5h1a.25.25 0 0 1 .25.25v7a.25.25 0 0 1-.25.25h-9.5A.25.25 0 0 1 3 12.5V10a.75.75 0 0 0-1.5 0v2.5c0 .966.784 1.75 1.75 1.75h9.5a1.75 1.75 0 0 0 1.75-1.75v-7a1.75 1.75 0 0 0-1.75-1.75h-1z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                              </span>
                                              <span
                                                data-testid="editor-toolbar-button-quote"
                                                role="button"
                                                tabIndex={0}
                                                className="sc-nzvvjc-1 nFhsw"
                                              >
                                                <div className="sc-pmqc9t-0 cWaPnd">
                                                  <span
                                                    data-nc="true"
                                                    className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                  >
                                                    Quote
                                                  </span>
                                                  <span className="sc-nzvvjc-0 dCsVYd">
                                                    &gt; Space
                                                  </span>
                                                </div>
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="QuoteIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    d="M11.318 4.678c-1.037 1.296-1.186 2.603-.882 3.517.514-.397 1.073-.595 1.676-.595C13.697 7.6 15 8.655 15 10.488c0 1.685-1.293 2.888-2.888 2.888-2.356 0-3.44-2.078-3.44-4.41 0-1.513.386-2.87 1.158-4.067C10.6 3.7 11.766 2.735 13.324 2l.42.816c-.941.396-1.75 1.017-2.426 1.862zm-7.672 0c-1.038 1.296-1.187 2.603-.882 3.517 1.152-.914 2.751-.723 3.726.187.984.92 1.069 2.536.44 3.583a2.88 2.88 0 0 1-2.49 1.41C2.083 13.376 1 11.299 1 8.968c0-1.514.386-2.87 1.158-4.068.771-1.2 1.936-2.165 3.494-2.9l.419.816c-.941.396-1.75 1.017-2.425 1.862z"
                                                  />
                                                </svg>
                                              </span>
                                              <span
                                                data-testid="editor-toolbar-button-strikethrough"
                                                role="button"
                                                tabIndex={0}
                                                className="sc-nzvvjc-1 nFhsw"
                                              >
                                                <div className="sc-pmqc9t-0 cWaPnd">
                                                  <span
                                                    data-nc="true"
                                                    className="textstyled__StyledText-sc-cx1866-0 hRpReS"
                                                  >
                                                    Strikethrough
                                                  </span>
                                                  <span className="sc-nzvvjc-0 dCsVYd">
                                                    ⌘ + Option + X
                                                  </span>
                                                </div>
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="TextOverlineIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    d="M8.875 2.75h2.96c.33 0 .634.187.782.484L13.25 4.5h.875V1H1.875v3.5h.875l.633-1.266a.875.875 0 0 1 .783-.484h2.959v4.375H1v1.75h14v-1.75H8.875V2.75zm0 9.87v-1.995h-1.75v1.994a.875.875 0 0 1-.598.83l-2.027.676V15h7v-.875l-2.027-.676a.875.875 0 0 1-.598-.83v.001z"
                                                  />
                                                </svg>
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                            <div className="sc-5zf3yx-0 jGoGrw">
                                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                                <span className="sc-17c5ac2-4 hYPJLu">
                                                  <span>
                                                    <span className="sc-17c5ac2-0 eWWHhb">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="CheckmarkCircleIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <g fill="currentColor">
                                                          <path d="m4 8.6 2.9 2.8 5.1-5L10.6 5 6.8 8.6 5.4 7.2 4 8.6z" />
                                                          <path
                                                            fillRule="evenodd"
                                                            d="M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z"
                                                            clipRule="evenodd"
                                                          />
                                                        </g>
                                                      </svg>
                                                    </span>
                                                    <span className="sc-17c5ac2-3 eDoNZr" />
                                                    <span className="sc-17c5ac2-1 juapBV">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="CheckmarkCircleFilledIcon"
                                                        className="sc-11y93t1-0 xIpMQ ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          d="M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm4 .6 2.9 2.8 5.1-5L10.6 5 6.8 8.6 5.4 7.2 4 8.6z"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                    </span>
                                                    <span className="sc-17c5ac2-2 RSLdb">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="AlertIcon"
                                                        className="sc-11y93t1-0 koulIT ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          d="M15.731 12.437 9.268 1.055c-.697-1.407-1.838-1.407-2.535 0L.269 12.437c-.697 1.407.008 2.56 1.566 2.56h12.329c1.559 0 2.264-1.152 1.567-2.56zM6.996 4.798a.81.81 0 0 1 .806-.81h.378c.443 0 .807.364.807.81v4.383c0 .445-.363.81-.807.81h-.378a.81.81 0 0 1-.806-.81V4.798zm2.014 7.367a.838.838 0 0 1-.838.832h-.331a.838.838 0 0 1-.837-.832v-.329c0-.458.377-.832.837-.832h.331c.461 0 .838.374.838.832v.33z"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                    </span>
                                                    <span className="sc-17c5ac2-2 RSLdb">
                                                      <svg
                                                        height="16px"
                                                        width="16px"
                                                        viewBox="0 0 16 16"
                                                        role="img"
                                                        aria-label="AlertIcon"
                                                        className="sc-11y93t1-0 koulIT ui-icon"
                                                      >
                                                        <path
                                                          fill="currentColor"
                                                          fillRule="evenodd"
                                                          d="M15.731 12.437 9.268 1.055c-.697-1.407-1.838-1.407-2.535 0L.269 12.437c-.697 1.407.008 2.56 1.566 2.56h12.329c1.559 0 2.264-1.152 1.567-2.56zM6.996 4.798a.81.81 0 0 1 .806-.81h.378c.443 0 .807.364.807.81v4.383c0 .445-.363.81-.807.81h-.378a.81.81 0 0 1-.806-.81V4.798zm2.014 7.367a.838.838 0 0 1-.838.832h-.331a.838.838 0 0 1-.837-.832v-.329c0-.458.377-.832.837-.832h.331c.461 0 .838.374.838.832v.33z"
                                                          clipRule="evenodd"
                                                        />
                                                      </svg>
                                                    </span>
                                                  </span>
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                          
                                        </div>
                                      </div>
                                      
                                    </div>
                                    
                                  </div>
                                  
                                </div>
                                <div className="sc-5zf3yx-1 cSxwAI">
                                  <div className="sc-5zf3yx-0 sc-5zf3yx-2 jGoGrw eauTTT">
                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                      <span className="sc-17c5ac2-4 hYPJLu">
                                        <span>
                                          <span className="sc-17c5ac2-0 eWWHhb">
                                            <svg
                                              height="16px"
                                              width="16px"
                                              viewBox="0 0 16 16"
                                              role="img"
                                              aria-label="CheckmarkCircleIcon"
                                              className="sc-11y93t1-0 xIpMQ ui-icon"
                                            >
                                              <g fill="currentColor">
                                                <path d="m4 8.6 2.9 2.8 5.1-5L10.6 5 6.8 8.6 5.4 7.2 4 8.6z" />
                                                <path
                                                  fillRule="evenodd"
                                                  d="M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z"
                                                  clipRule="evenodd"
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                          <span className="sc-17c5ac2-3 eDoNZr" />
                                          <span className="sc-17c5ac2-1 juapBV">
                                            <svg
                                              height="16px"
                                              width="16px"
                                              viewBox="0 0 16 16"
                                              role="img"
                                              aria-label="CheckmarkCircleFilledIcon"
                                              className="sc-11y93t1-0 xIpMQ ui-icon"
                                            >
                                              <path
                                                fill="currentColor"
                                                fillRule="evenodd"
                                                d="M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm4 .6 2.9 2.8 5.1-5L10.6 5 6.8 8.6 5.4 7.2 4 8.6z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                          <span className="sc-17c5ac2-2 RSLdb">
                                            <svg
                                              height="16px"
                                              width="16px"
                                              viewBox="0 0 16 16"
                                              role="img"
                                              aria-label="AlertIcon"
                                              className="sc-11y93t1-0 koulIT ui-icon"
                                            >
                                              <path
                                                fill="currentColor"
                                                fillRule="evenodd"
                                                d="M15.731 12.437 9.268 1.055c-.697-1.407-1.838-1.407-2.535 0L.269 12.437c-.697 1.407.008 2.56 1.566 2.56h12.329c1.559 0 2.264-1.152 1.567-2.56zM6.996 4.798a.81.81 0 0 1 .806-.81h.378c.443 0 .807.364.807.81v4.383c0 .445-.363.81-.807.81h-.378a.81.81 0 0 1-.806-.81V4.798zm2.014 7.367a.838.838 0 0 1-.838.832h-.331a.838.838 0 0 1-.837-.832v-.329c0-.458.377-.832.837-.832h.331c.461 0 .838.374.838.832v.33z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                          <span className="sc-17c5ac2-2 RSLdb">
                                            <svg
                                              height="16px"
                                              width="16px"
                                              viewBox="0 0 16 16"
                                              role="img"
                                              aria-label="AlertIcon"
                                              className="sc-11y93t1-0 koulIT ui-icon"
                                            >
                                              <path
                                                fill="currentColor"
                                                fillRule="evenodd"
                                                d="M15.731 12.437 9.268 1.055c-.697-1.407-1.838-1.407-2.535 0L.269 12.437c-.697 1.407.008 2.56 1.566 2.56h12.329c1.559 0 2.264-1.152 1.567-2.56zM6.996 4.798a.81.81 0 0 1 .806-.81h.378c.443 0 .807.364.807.81v4.383c0 .445-.363.81-.807.81h-.378a.81.81 0 0 1-.806-.81V4.798zm2.014 7.367a.838.838 0 0 1-.838.832h-.331a.838.838 0 0 1-.837-.832v-.329c0-.458.377-.832.837-.832h.331c.461 0 .838.374.838.832v.33z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-nc="true"
                              role="separator"
                              className="dividerstyled__StyledDivider-sc-11zu58w-0 keGZPi"
                            >
                              <div className="dividerstyled__StyledDividerInner-sc-11zu58w-1 kxdkKZ" />
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 khRsCh">
                              <div className="box__StyledBox-sc-b30x7m-0 fRtibd">
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                  <span className="sidebar-attribute-rowstyled__Icon-sc-4mgsuv-0 bsEYEz">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="CalendarIcon"
                                      className="sc-11y93t1-0 xIpMQ ui-icon"
                                    >
                                      <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M5.429 0c.473 0 .857.392.857.875v.875h3.428V.875c0-.483.384-.875.857-.875.474 0 .858.392.858.875v.875h1.857c.947 0 1.714.784 1.714 1.75v9.75c0 .966-.768 1.75-1.714 1.75H2.714C1.768 15 1 14.216 1 13.25V3.5c0-.966.768-1.75 1.714-1.75h1.857V.875c0-.483.384-.875.858-.875zM2.714 5.25v8h10.572v-8H2.714z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </span>
                                  <div className="sidebar-attribute-rowstyled__Title-sc-4mgsuv-1 QcUVW">
                                    Timeframe
                                  </div>
                                  <div
                                    className="flexstyled__StyledFlex-sc-lvlevv-0 cquxeH"
                                    data-testid="Sidebar-Timeframe-Container"
                                  >
                                    <div
                                      data-testid="timeframe-value"
                                      className="timeframe-valuestyled__Container-sc-ia8xov-0 ksjSWC"
                                    >
                                      <div className="timeframe-valuestyled__Wrapper-sc-ia8xov-2 hWdTKq">
                                        <span
                                          data-testid="Sidebar-Timeframe-FromLabel"
                                          data-nc="true"
                                          className="textstyled__StyledText-sc-cx1866-0 eheNCz"
                                        >
                                          <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                            Oct 15, 2023
                                          </div>
                                        </span>
                                        <div className="timeframe-valuestyled__IconWrapper-sc-ia8xov-4 zypFL">
                                          <svg
                                            height="12px"
                                            width="12px"
                                            viewBox="0 0 16 16"
                                            role="img"
                                            aria-label="ArrowLongRightIcon"
                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                          >
                                            <path
                                              fill="currentColor"
                                              d="M2 8.379a.6.6 0 0 0 .6.6H10v1.923c0 .526.6.795.96.43l2.866-2.902a.618.618 0 0 0 0-.86L10.96 4.668c-.36-.365-.96-.096-.96.43v1.88H2.6a.6.6 0 0 0-.6.6v.8z"
                                            />
                                          </svg>
                                        </div>
                                        <span
                                          data-testid="Sidebar-Timeframe-ToLabel"
                                          data-nc="true"
                                          className="textstyled__StyledText-sc-cx1866-0 eheNCz"
                                        >
                                          <div className="timeframe-valuestyled__Transition-sc-ia8xov-1 ernMrX">
                                            Dec 9, 2023
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-nc="true"
                              role="separator"
                              className="dividerstyled__StyledDivider-sc-11zu58w-0 keGZPi"
                            >
                              <div className="dividerstyled__StyledDividerInner-sc-11zu58w-1 kxdkKZ" />
                            </div>
                            <div className="box__StyledBox-sc-b30x7m-0 khRsCh">
                              <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                <span className="sidebar-attribute-rowstyled__Icon-sc-4mgsuv-0 bsEYEz">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="PercentageIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <path
                                      fill="currentColor"
                                      fillRule="evenodd"
                                      d="M4 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-1.803a1.197 1.197 0 1 0 0-2.394 1.197 1.197 0 0 0 0 2.394zm-.378 8.595a.931.931 0 0 1-1.316-1.316l10.27-10.27a.931.931 0 0 1 1.316 1.317l-10.27 10.27zM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-1.702.048a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </span>
                                <div className="sidebar-attribute-rowstyled__Title-sc-4mgsuv-1 QcUVW">
                                  Progress
                                </div>
                                <div className="flexstyled__StyledFlex-sc-lvlevv-0 cquxeH">
                                  <div className="flexstyled__StyledFlex-sc-lvlevv-0 pQSMa">
                                    <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                        <div className="box__StyledBox-sc-b30x7m-0 LXZOB">
                                          <div className="box__StyledBox-sc-b30x7m-0 eeBsTh">
                                            <div
                                              overflow="hidden"
                                              className="box__StyledBox-sc-b30x7m-0 gyTYYS"
                                            >
                                              <div
                                                value={0}
                                                data-testid="ProgressIndicatorThumb"
                                                className="bar-indicatorstyled__Thumb-sc-1xi1nqe-0 bYtoou"
                                                style={{
                                                  transform: "translateX(-100%)"
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="percentage-inputstyled__Wrapper-sc-1yd6uy5-0 ersLwy">
                                          <input
                                            data-testid="ProgressIndicatorText"
                                            type="number"
                                            disabled=""
                                            className="percentage-inputstyled__Input-sc-1yd6uy5-1 hcjMBj"
                                            defaultValue={0}
                                          />
                                          <div className="percentage-inputstyled__PercentSign-sc-1yd6uy5-2 eZOBKI">
                                            %
                                          </div>
                                        </div>
                                      </div>
                                    </span>
                                    <div className="flexstyled__StyledFlex-sc-lvlevv-0 fjGXki">
                                      <span
                                        data-nc="true"
                                        className="textstyled__StyledText-sc-cx1866-0 clvMfG"
                                      >
                                        Manual
                                      </span>
                                      <div className="flexstyled__StyledFlex-sc-lvlevv-0 iDRXau">
                                        <div
                                          data-testid="ProgressMode-Toggle"
                                          className="switchstyled__Wrapper-sc-msfgbt-0 egqZJi"
                                        >
                                          <input
                                            id="6233b070-6a23-42e1-951c-2d0cee08140c"
                                            type="checkbox"
                                            data-testid="UiSwitchToggle-UnChecked"
                                            className="switchstyled__Input-sc-msfgbt-2 sbnpW"
                                          />
                                          <label
                                            htmlFor="6233b070-6a23-42e1-951c-2d0cee08140c"
                                            className="switchstyled__Label-sc-msfgbt-1 fYxouf"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="box__StyledBox-sc-b30x7m-0 SKZjH">
                                <div className="sc-5x6jut-1 jZMTit">
                                  <svg
                                    height="16px"
                                    width="16px"
                                    viewBox="0 0 16 16"
                                    role="img"
                                    aria-label="FeaturesIcon"
                                    className="sc-11y93t1-0 xIpMQ ui-icon"
                                  >
                                    <g fill="currentColor">
                                      <path d="M12 7H4v2h8V7zM4 4h8v2H4V4zm4 6H4v2h4v-2z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 2v12H2V2h12z"
                                        clipRule="evenodd"
                                      />
                                    </g>
                                  </svg>
                                  <div className="sidebar-collapsible-section__Header-sc-2ly597-0 daBzRS">
                                    <div className="sidebar-collapsible-section__HeaderInfo-sc-2ly597-1 fsLPVf">
                                      <div className="sidebar-collapsible-section__HeaderTitle-sc-2ly597-2 kJYsEY">
                                        <div className="sidebar-collapsible-section__Title-sc-2ly597-3 ktflxx">
                                          <span
                                            data-nc="true"
                                            className="textstyled__StyledText-sc-cx1866-0 fGIIpX"
                                          >
                                            Features
                                          </span>
                                        </div>
                                        <span
                                          data-nc="true"
                                          className="textstyled__StyledText-sc-cx1866-0 bFvkTA"
                                        >
                                          (&nbsp;1&nbsp;)
                                        </span>
                                        <div className="sidebar-collapsible-section__Arrow-sc-2ly597-4 iUrhmb">
                                          <svg
                                            height="16px"
                                            width="16px"
                                            viewBox="0 0 16 16"
                                            role="img"
                                            aria-label="ChevronDownIcon"
                                            className="sc-11y93t1-0 xIpMQ ui-icon"
                                          >
                                            <path
                                              fill="currentColor"
                                              fillRule="evenodd"
                                              d="m7.22 10.681-3.897-3.83a1.07 1.07 0 0 1 0-1.534 1.115 1.115 0 0 1 1.558 0L8 8.382l3.118-3.065a1.117 1.117 0 0 1 1.56 0c.43.423.43 1.11 0 1.533L8.78 10.681a1.116 1.116 0 0 1-1.559 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <span
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 dQHpLx"
                                    >
                                      Effort
                                    </span>
                                    <span
                                      data-nc="true"
                                      className="textstyled__StyledText-sc-cx1866-0 bFvkTA"
                                    >
                                      &nbsp;(&nbsp;5&nbsp;)
                                    </span>
                                  </div>
                                  <div className="sc-qtz8hs-1 dAblMh">
                                    <div className="l306g84_3PfGluK5_5Vx">
                                      <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                        <svg
                                          viewBox="0 0 16 16"
                                          className="O4k_TaPk0Yyar4vmBDk4 uduOF4IAC8pwfDSf6HnG oMiYLvQo1yWeDHfp87d2 pb-icon"
                                          data-testid="FeatureIcon-feature"
                                        >
                                          <path d="M4 0h8c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z" />
                                        </svg>
                                      </span>
                                    </div>
                                    <a
                                      title="Sample feature 1"
                                      className="sc-qtz8hs-0 fNvvFI"
                                      href="/feature-board/7450405-feature-planning-sample/features/24723141/detail"
                                    >
                                      Sample feature 1
                                    </a>
                                  </div>
                                  <span
                                    data-nc="true"
                                    className="textstyled__StyledText-sc-cx1866-0 RDWoP"
                                  >
                                    5
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              data-nc="true"
                              role="separator"
                              className="dividerstyled__StyledDivider-sc-11zu58w-0 kuBhgB"
                            >
                              <div className="dividerstyled__StyledDividerInner-sc-11zu58w-1 kxdkKZ" />
                            </div>
                            <div className="sc-1b2myj8-0 hlUspo">
                              <div>
                                <div className="sc-8qtgnr-3 eqzHgi">
                                  <div
                                    className="flexstyled__StyledFlex-sc-lvlevv-0 cPkKOX"
                                    data-testid="SidebarSectionSwitcher-StaticContainer"
                                  >
                                    <div
                                      data-testid="feature-sections-switcher"
                                      className="switcher__Container-sc-1uhw788-0 bEryll"
                                    >
                                      <div className="segmented-controlstyled__Wrapper-sc-1gluriv-0 jGkPGN">
                                        <div className="segmented-controlstyled__Slider-sc-1gluriv-1 fLvSbL" />
                                        <div className="flexstyled__StyledFlex-sc-lvlevv-0 jSOMYj">
                                          <div
                                            tabIndex={0}
                                            type="compact"
                                            data-testid="SidebarSectionSwitcher-Comments-active"
                                            className="segmented-control-itemstyled__Wrapper-sc-1exbble-0 gAhfFa"
                                          >
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 SBvD">
                                              <div
                                                type="compact"
                                                className="segmented-control-itemstyled__Icon-sc-1exbble-1 kAAIYJ"
                                              >
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="CommentIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    fillRule="evenodd"
                                                    d="M3.069 12H3v3.999L7.5 13h2A6.5 6.5 0 0 0 9.5.001h-3A6.5 6.5 0 0 0 0 6.5c.001 2.326 1.233 4.352 3.069 5.5zM6.5 2.001h3A4.5 4.5 0 0 1 9.5 11h-2L5 12.5v-1.775c-1.744-.62-3-2.268-3-4.225a4.5 4.5 0 0 1 4.5-4.499z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                              </div>
                                              <span
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 eHBwTk"
                                              >
                                                Comments
                                              </span>
                                            </div>
                                          </div>
                                          <div
                                            tabIndex={0}
                                            type="compact"
                                            data-testid="SidebarSectionSwitcher-Logs"
                                            className="segmented-control-itemstyled__Wrapper-sc-1exbble-0 dgNwqJ"
                                          >
                                            <div className="flexstyled__StyledFlex-sc-lvlevv-0 SBvD">
                                              <div
                                                type="compact"
                                                className="segmented-control-itemstyled__Icon-sc-1exbble-1 kAAIYJ"
                                              >
                                                <svg
                                                  height="16px"
                                                  width="16px"
                                                  viewBox="0 0 16 16"
                                                  role="img"
                                                  aria-label="InfoCircleIcon"
                                                  className="sc-11y93t1-0 xIpMQ ui-icon"
                                                >
                                                  <path
                                                    fill="currentColor"
                                                    fillRule="evenodd"
                                                    d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6.001 6.001 0 0 1 8 2c3.312 0 6 2.687 6 6s-2.688 6-6 6zM7 6h1.999V4H7v2zm0 6h1.999V7H7v5z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                              </div>
                                              <span
                                                data-nc="true"
                                                className="textstyled__StyledText-sc-cx1866-0 eHBwTk"
                                              >
                                                History
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              <div
                                data-testid="discussion-wrapper"
                                className="UZcRFVd8Zvx6WB7UWjys discussion"
                              >

                                <div className="xWNDBu_qrXD1n5gHJvib">


                                  <div>
                                    <div style={{ width:"60px"}} className="TI1TzqMXsuFccidbKJhx">
                                      <div style={{margin:"4px"}}>
                                        <VeltRecorderTool type="all" panelId="2"/>
                                      </div>
                                    </div>

                                  </div>
                                  <div className="u3z8lcWNWypPzqtlFyhC">
                                    <div className="n42oZh3efdjC7ivyy8A3">
                                      <div />
                                      <div
                                        style={{
                                          alignItems: "center",
                                          height: 44
                                        }}
                                      >
                                        <div style={{border: "1px solid #e1e6ea"}}>


                                        <textarea
                                          width="500px"
                                          placeholder="Write a comment..."
                                          data-perf="Comment-Input"
                                          className="r158DC7q4rdWABXZBrss VkEKHJ9i4rXrbWPqKGAQ FfUcnoViKKpcW5DCV5Pa"
                                          data-testid="Sidebar-CommentInput-Field"
                                          data-nc="true"
                                          style={{ height: 44, border:"none" }}
                                          defaultValue={""}
                                        >
                                      
                                        </textarea>
                                        {
                                        recordedDataComments.map((data) => {
                                            return (
                                                // This is alternative way to render the recorded data
                                                // <div key={data.id} dangerouslySetInnerHTML={{ __html: data.tag }}></div>
                                                // STEP 5.c
                                                <div key={data.id} style={{margin:"8px"}}>
                                                    <VeltRecorderPlayer recorderId={data.id} />
                                                </div>
                                            )
                                        })
                                      }
                                        
                                        </div>
                                        
                                        
                                      </div>
                                      
                                    </div>
                                    
                                  </div>
                                  
                                </div>
                                
                              </div>
                              
                            </div>
                            
                            <div id="sidebar-portal" />
                          </div>
                          <div id="toolbar-portal">
                            <div />
                          </div>
                        </div>
                      </div>
                      <div
                        className="c1alsBMGLxftNgJdiVQG"
                        data-testid="ActionFooterContainer"
                      >
                        <div className="gsai50QCbMxF4P_Lbzpg">
                          <div
                            data-testid="Followers-FollowersStack"
                            className="sc-1t70ec6-0 hNwVlo"
                          >
                            <div className="box__StyledBox-sc-b30x7m-0 GuxjT">
                              <div>
                                <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                  <button
                                    type="button"
                                    data-nc="true"
                                    data-testid="Followers-QuickFollowButton"
                                    className="button-primitive__StyledButton-sc-1guvopt-0 TubNC"
                                  >
                                    <span className="button-primitive__StyledContent-sc-1guvopt-1 jabxlH">
                                      <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                        Follow
                                      </span>
                                    </span>
                                  </button>
                                </span>
                              </div>
                            </div>
                            <div>
                              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                                <button
                                  type="button"
                                  data-nc="true"
                                  data-testid="Followers-Add-Follower-Button"
                                  className="button-primitive__StyledButton-sc-1guvopt-0 cILOVY"
                                >
                                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                                    <svg
                                      height="16px"
                                      width="16px"
                                      viewBox="0 0 16 16"
                                      role="img"
                                      aria-label="FollowerIcon"
                                      className="sc-11y93t1-0 dqXaRM ui-icon"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M2.006 13.624a.366.366 0 0 0 .369.375h1.65a.387.387 0 0 0 .382-.375 9.6 9.6 0 0 1 9.218-9.217.387.387 0 0 0 .375-.383v-1.65a.366.366 0 0 0-.375-.369 12 12 0 0 0-11.62 11.62Zm4.733.378a.361.361 0 0 1-.366-.375 7.64 7.64 0 0 1 7.256-7.255.361.361 0 0 1 .375.366v1.25a.395.395 0 0 1-.375.388 5.64 5.64 0 0 0-5.251 5.252.395.395 0 0 1-.388.374H6.74Zm3.82.001c-.207 0-.377-.168-.357-.374a3.822 3.822 0 0 1 3.427-3.427c.206-.02.375.15.375.356v1.023c0 .207-.17.372-.373.41a2.051 2.051 0 0 0-1.64 1.64c-.038.203-.202.372-.41.372H10.56Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </div>
                                  <span className="button-primitive__StyledContent-sc-1guvopt-1 jnjmlp">
                                    <span className="button-primitive__StyledTextMain-sc-1guvopt-2 iEmEjZ">
                                      <span
                                        data-nc="true"
                                        className="textstyled__StyledText-sc-cx1866-0 yWKmj"
                                      >
                                        0
                                      </span>
                                    </span>
                                  </span>
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="D80qbj1c6t2MHr5soHzy NhiCduVduFYYVbOKfVE5">
            <div className="sc-xo5ppy-0 hVhcev">
              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                <button
                  type="button"
                  aria-label="Close sidebar (Esc)"
                  data-nc="true"
                  data-testid="Sidebar-CloseButton"
                  className="button-primitive__StyledButton-sc-1guvopt-0 hmxuuK"
                >
                  <div className="button-primitive__IconWrapper-sc-1guvopt-5 haBKUc">
                    <svg
                      height="16px"
                      width="16px"
                      viewBox="0 0 16 16"
                      role="img"
                      aria-label="RemoveIcon"
                      className="sc-11y93t1-0 dqXaRM ui-icon"
                    >
                      <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M8 6.441 4.882 3.323a1.101 1.101 0 1 0-1.558 1.559L6.442 8l-3.119 3.118a1.102 1.102 0 1 0 1.559 1.56l3.119-3.12 3.118 3.119a1.102 1.102 0 1 0 1.558-1.559L9.559 8l3.119-3.118a1.102 1.102 0 0 0-1.56-1.56L8 6.443z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </button>
              </span>
            </div>
          </div>
          <div
            className="YPhjEfZFRZNuqGKZkVg4 HzP01z9Omj_cNAOvf1yz"
            data-testid="Sidebar-Menu"
          />
          <div className="sc-1rpu86o-0 iiizaW">
            <div id="floating-actions" className="sc-1rpu86o-1 dQtPHH" />
            <div className="sc-1rpu86o-2 keUbDp">
              <span className="tooltip-primitivestyled__TooltipChildrenWrapper-sc-8f8yn5-5 efA-DxL">
                <a data-testid="HelpMenu-Button" className="sc-ya26g2-1 jfftCp">
                  <svg
                    height="16px"
                    width="16px"
                    viewBox="0 0 16 16"
                    role="img"
                    aria-label="QuestionMarkIcon"
                    className="sc-11y93t1-0 jMzzJy ui-icon"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.88 11.67h2.357V14H6.88v-2.33ZM5.57 2.613C6.193 2.204 6.954 2 7.859 2c1.189 0 2.175.29 2.962.87.785.58 1.18 1.44 1.18 2.579 0 .699-.17 1.287-.512 1.765-.201.29-.582.66-1.15 1.113l-.556.444c-.305.24-.508.523-.606.845-.063.204-.099.521-.104.95H6.934c.031-.907.116-1.534.253-1.88.136-.347.487-.746 1.054-1.197l.575-.46c.188-.145.34-.304.455-.475.21-.297.314-.621.314-.977 0-.407-.117-.78-.35-1.115-.232-.337-.66-.504-1.278-.504-.609 0-1.04.207-1.296.62a2.432 2.432 0 0 0-.381 1.29H4c.063-1.531.587-2.617 1.57-3.256Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div id="popup" />
        <div id="deprecated_tooltip" />
        <div id="tooltip" />
        <div id="snippet-popup-portal" />
        <div id="helper-portal" />
        <div id="dropdown-portal" />
        <div id="modal-portal" />
        <div id="portal-card-detail" />
        <div id="onboarding_tooltip" />
      </div>
    </div>
    <div
      style={{
        position: "fixed",
        zIndex: 7000002,
        inset: 16,
        pointerEvents: "none"
      }}
    />
  </section>
  <iframe
    id="intercom-frame"
    style={{
      position: "absolute !important",
      opacity: "0 !important",
      width: "1px !important",
      height: "1px !important",
      top: "0 !important",
      left: "0 !important",
      border: "none !important",
      display: "block !important",
      zIndex: "-1 !important",
      pointerEvents: "none"
    }}
    aria-hidden="true"
    tabIndex={-1}
    title="Intercom"
  />
  <div
    id="batBeacon608340721008"
    style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
  >
    <img
      id="batBeacon347405191127"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&pi=918639831&lg=en-US&sw=1512&sh=982&sc=30&tl=Productboard&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&r=https%3A%2F%2Fapp.productboard.com%2F&lt=812&evt=pageLoad&sv=1&rn=785303"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon494545397602"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20javascript&el2=User%20load%20javascript&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=489363"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon840112026834"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20all%20perf&el2=User%20load%20all%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=568323"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon422421442306"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Smarter%20json%20mvb%20data%20loaded&el2=Smarter%20json%20mvb%20data%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=791632"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon315519079323"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20shell%20loaded&el2=App%20shell%20loaded&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=591829"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon598964885277"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=App%20loaded%20all%20smarter%20json%20data&el2=App%20loaded%20all%20smarter%20json%20data&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=609019"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon406274503357"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=User%20load%20perf&el2=User%20load%20perf&p=https%3A%2F%2Fvelt.productboard.com%2Fwelcome&sw=1512&sh=982&sc=30&evt=custom&rn=547001"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon487774063225"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Onboarding%20home%20viewed&el2=Onboarding%20home%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Fhome&sw=1512&sh=982&sc=30&evt=custom&rn=102407"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon429688104695"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Navigation%20folder%20contents%20toggled&el2=Navigation%20folder%20contents%20toggled&p=https%3A%2F%2Fvelt.productboard.com%2Fhome&sw=1512&sh=982&sc=30&evt=custom&rn=838634"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon744975267048"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Fhome&sw=1512&sh=982&sc=30&evt=custom&rn=857313"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon451102051044"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Fhome&sw=1512&sh=982&sc=30&evt=custom&rn=644734"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon443602949342"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Navigation%20folder%20contents%20toggled&el2=Navigation%20folder%20contents%20toggled&p=https%3A%2F%2Fvelt.productboard.com%2Fhome&sw=1512&sh=982&sc=30&evt=custom&rn=48968"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon597905533816"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=All%20teamspaces%20clicked&el2=All%20teamspaces%20clicked&p=https%3A%2F%2Fvelt.productboard.com%2Fteamspaces%2Fall&sw=1512&sh=982&sc=30&evt=custom&rn=9086"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon315463644286"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Navigation%20folder%20contents%20toggled&el2=Navigation%20folder%20contents%20toggled&p=https%3A%2F%2Fvelt.productboard.com%2Fteamspaces%2Fall&sw=1512&sh=982&sc=30&evt=custom&rn=102375"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon316708338947"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Fteamspaces%2Fall&sw=1512&sh=982&sc=30&evt=custom&rn=55737"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon168676884614"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20upgrade%20prompt%20shown&el2=Trial%20upgrade%20prompt%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Fteamspaces%2Fall&sw=1512&sh=982&sc=30&evt=custom&rn=97034"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon410761659843"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=111063"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon476589090884"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20viewed&el2=Features%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=599886"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon297246432325"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Share%20view%20button%20viewed&el2=Share%20view%20button%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=611549"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon498331779160"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Feature%20import%20banner%20shown&el2=Feature%20import%20banner%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=749793"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon997062660345"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Navigation%20folder%20contents%20toggled&el2=Navigation%20folder%20contents%20toggled&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=447142"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon834779200332"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=665183"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon303812215790"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Roadmap%20board%20viewed&el2=Roadmap%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=871544"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon869141735274"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=632835"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon576242145189"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20viewed&el2=Features%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=673355"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon819024544997"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Share%20view%20button%20viewed&el2=Share%20view%20button%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=796150"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon349015425784"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Feature%20import%20banner%20shown&el2=Feature%20import%20banner%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=312013"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon448537890784"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=591960"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon799848098748"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20section%20tab%20clicked&el2=Sidebar%20section%20tab%20clicked&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=388279"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon316611528926"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20section%20tab%20clicked&el2=Sidebar%20section%20tab%20clicked&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=715775"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon731346313604"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=539737"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon35280677278"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20viewed&el2=Features%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample&sw=1512&sh=982&sc=30&evt=custom&rn=760920"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon576372914098"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample%2Ffeatures%2F24723139%2Fdetail&sw=1512&sh=982&sc=30&evt=custom&rn=560173"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon362480309030"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Feature%20detail%20shown&ec=pnr&el2=Feature%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample%2Ffeatures%2F24723139%2Fdetail&sw=1512&sh=982&sc=30&evt=custom&rn=275030"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon150620433198"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20modal%20viewed&el2=Trial%20modal%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample%2Ffeatures%2F24723139%2Fdetail&sw=1512&sh=982&sc=30&evt=custom&rn=795436"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon266997999270"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Trial%20modal%20closed&el2=Trial%20modal%20closed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450406-feature-prioritization-sample%2Ffeatures%2F24723139%2Fdetail&sw=1512&sh=982&sc=30&evt=custom&rn=174423"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon659031132202"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=213169"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon608060621826"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Roadmap%20board%20viewed&el2=Roadmap%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Froadmap%2F7450412-feature-launch-roadmap-sample&sw=1512&sh=982&sc=30&evt=custom&rn=175116"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon57787982004"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20opened&el2=Board%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=710505"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon143489210588"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Features%20board%20viewed&el2=Features%20board%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=754143"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon982200855732"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Share%20view%20button%20viewed&el2=Share%20view%20button%20viewed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=700151"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon658127251668"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Feature%20import%20banner%20shown&el2=Feature%20import%20banner%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=938715"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon153777019763"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=778559"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon924319811822"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20close%20button%20clicked&el2=Sidebar%20close%20button%20clicked&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample&sw=1512&sh=982&sc=30&evt=custom&rn=640182"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon459026521002"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416947&sw=1512&sh=982&sc=30&evt=custom&rn=295712"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon227947326498"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=925720"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon851055663666"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416947&sw=1512&sh=982&sc=30&evt=custom&rn=439691"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon527441145690"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Sidebar%20detail%20shown&el2=Sidebar%20detail%20shown&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=110952"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon903983255878"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Board%20context%20menu%20opened&el2=Board%20context%20menu%20opened&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=671423"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
    <img
      id="batBeacon275136848712"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=25136731&Ver=2&mid=1e8f6504-a713-408e-b203-966fea476d28&sid=b727d36087cd11eea6bf81cf7633dfc1&vid=b727e52087cd11eea6f943c67adb6568&vids=0&msclkid=N&ea=track&el=Editor%20content%20changed&el2=Editor%20content%20changed&p=https%3A%2F%2Fvelt.productboard.com%2Ffeature-board%2F7450405-feature-planning-sample%2Freleases%2F1416946&sw=1512&sh=982&sc=30&evt=custom&rn=426395"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
  </div>
  <div className="intercom-lightweight-app" />
  <iframe
    data-product="web_widget"
    title="No content"
    role="presentation"
    tabIndex={-1}
    allow="microphone *"
    aria-hidden="true"
    src="about:blank"
    style={{
      width: 0,
      height: 0,
      border: 0,
      position: "absolute",
      top: "-9999px"
    }}
  />
  <div>
    <iframe
      title="Opens a widget where you can chat to one of our agents"
      id="launcher"
      tabIndex={0}
      style={{
        colorScheme: "light",
        width: 0,
        height: 50,
        padding: 0,
        margin: "10px 20px",
        position: "fixed",
        bottom: 0,
        overflow: "visible",
        opacity: 1,
        border: 0,
        zIndex: 999998,
        transitionDuration: "250ms",
        transitionTimingFunction: "cubic-bezier(0.645, 0.045, 0.355, 1)",
        transitionProperty: "opacity, top, bottom",
        right: 0
      }}
    />
  </div>
  <div id="DndDescribedBy-0" style={{ display: "none" }}>
    To pick up a draggable item, press the space bar. While dragging, use the
    arrow keys to move the item. Press space again to drop the item in its new
    position, or press escape to cancel.
  </div>
  <div
    id="DndLiveRegion-0"
    role="status"
    aria-live="assertive"
    aria-atomic="true"
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      margin: "-1px",
      border: 0,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0px, 0px, 0px, 0px)",
      clipPath: "inset(100%)",
      whiteSpace: "nowrap"
    }}
  />
  <div id="DndDescribedBy-1" style={{ display: "none" }}>
    To pick up a draggable item, press the space bar. While dragging, use the
    arrow keys to move the item. Press space again to drop the item in its new
    position, or press escape to cancel.
  </div>
  <div
    id="DndLiveRegion-1"
    role="status"
    aria-live="assertive"
    aria-atomic="true"
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      margin: "-1px",
      border: 0,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0px, 0px, 0px, 0px)",
      clipPath: "inset(100%)",
      whiteSpace: "nowrap"
    }}
  />
  <iframe
    name="__privateStripeMetricsController2390"
    frameBorder={0}
    allowTransparency="true"
    scrolling="no"
    role="presentation"
    allow="payment *"
    src="https://js.stripe.com/v3/m-outer-27c67c0d52761104439bb051c7856ab1.html#url=https%3A%2F%2Fvelt.productboard.com&title=Productboard&referrer=https%3A%2F%2Fapp.productboard.com%2F&muid=NA&sid=NA&version=6&preview=false&metaReferrerPolicy=origin"
    aria-hidden="true"
    tabIndex={-1}
    style={{
      border: "none !important",
      margin: "0px !important",
      padding: "0px !important",
      width: "1px !important",
      minWidth: "100% !important",
      overflow: "hidden !important",
      display: "block !important",
      visibility: "hidden !important",
      position: "fixed !important",
      height: "1px !important",
      pointerEvents: "none !important",
      userSelect: "none !important"
    }}
  />
  <div id="rvNiWyVRbzxC" style={{ display: "none" }} />
</>

  )
}
